import { pouchdb2 } from '../pouchdb/pouchdb.service';
import { iConfiguracion } from '../../models/basePage';
import { Online } from '../../models/online/cfutbol';
import { APIOnLine } from '../api/api.services';
import { ToastController } from 'ionic-angular';
import { ConMensajes } from '../../models/PaginaBase';
import moment from 'moment';

/**
 * Este conjunto de clases servirá para AISLAR la obtención de los datos, independientemente de que se obtenga desde el API Online o desde la BD PouchDB.
 * Todas las clases, se heredarán de las clases de pouchdb2, porque tienen más campos que las clases similares en el módulo "Online" (tienen los campos _id, _rev y type),
 * así, cuando se utilicen desde la aplicación, se guardará correctamente la información de los registros de las tablas en la versión ON ONLINE.
 */
export namespace Proxy {

  export interface iProxy {
    CFutbolActas: APIOnLine.CFutbolActas;
    DBService2: pouchdb2.DBService2;
    Persistentes: APIOnLine.Persistentes;
  }

  // #region ActasAmonestaciones
  export class PrAmonestaciones extends pouchdb2.ActasAmonestacionesDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _idDesignacion: number = 0,
      _idAmonestacion: number = 0
    ) {
      super(nombreTabla, _idAmonestacion);
    }

    public Eliminar(): Promise<boolean> {
      let datos: PrAmonestaciones = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.eliminarAmonestacion(datos)
              .then((resultado: boolean) => {
                return Promise.resolve(resultado);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            // TODO: Realizar versión desconecada
            return Promise.resolve(true);
          }
        })
        .catch(error => Promise.reject("ERROR al eliminar la amonestación de la designación " + this.idDesignacion.toString() + ": " + error));
    }

    public Guardar(): Promise<PrAmonestaciones> {
      let datos: PrAmonestaciones = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.guardarAmonestacion(datos)
              .then((resultado: Online.IActas_Amonestaciones_Base) => {
                if (resultado != null && resultado.idAmonestacion > 0) {
                  this.idAmonestacion = resultado.idAmonestacion;
                  return Promise.resolve(this);
                }
                else {
                  return Promise.reject("No se han podido guardar los datos de la amonestación en el servidor.");
                }
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            // TODO: Realizar versión desconecada
            return Promise.resolve(null);
          }
        })
        .catch(error => Promise.reject("ERROR al guardar la amonestación de la designación" + this.idDesignacion.toString() + ": " + error));
    }
  }

  export class ListaPrAmonestaciones extends ConMensajes {
    public lista: Array<PrAmonestaciones>;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public toastCtrl: ToastController,
      public designacion: PrDesignaciones,
      public idEquipo: number
    ) {
      super(toastCtrl);
      this.lista = [];
    }

    public CargarAmonestaciones(_esIncidencia: boolean): Promise<boolean> {
      this.lista = [];

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // VERSIÓN ONLINE
            return this.CFutbolActas.amonestacionesPorDesignacion(this.designacion.urlApi, this.designacion.idDesignacion, this.idEquipo)
              .then((resultado: Array<Online.IActas_Amonestaciones_Base>) => {
                // Creación del array
                resultado.forEach((valor: Online.IActas_Amonestaciones_Base) => {
                  if (valor.esIncidencia == _esIncidencia) {
                    this.lista.push(Object.assign(new PrAmonestaciones(this.CFutbolActas, this.DBService2, this.Persistentes), valor));
                  }
                });

                return Promise.resolve(true);
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener las personas alineables."));
          }
          else {
            // VERSIÓN DESCONECTADA
            return Promise.resolve(true);
          }
        })
        .catch(error => Promise.reject("ERROR al obtener las amonestaciones de la designación actual: " + error));
    }

    /**
     * Indica si el participante ya tiene una amonestación.
     * @param idJugador Identificador del participante
     * @param codigos Lista de códigos de amonestación
     */
    public TieneAmonestacion(idJugador: number, codigos: ListaPrCodigoAmonestacion): boolean {
      let resultado: boolean = false;

      if (this.lista.length > 0) {
        this.lista.forEach((valor: PrAmonestaciones) => {
          if (valor.idJugador == idJugador && codigos.EsAmonestacion(valor.amonestacion)) {
            resultado = true;
          }
        });
      }

      return resultado;
    }
  }
  // #endregion

  // #region ActasCambios
  export class PrCambios extends pouchdb2.ActasCambiosDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _idDesignacion: number = 0,
      _idAmonestacion: number = 0
    ) {
      super(nombreTabla, _idAmonestacion);
    }

    public Eliminar(): Promise<boolean> {
      let datos: PrCambios = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.eliminarCambio(datos)
              .then((resultado: boolean) => {
                return Promise.resolve(resultado);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            // TODO: Realizar versión desconecada
            return Promise.resolve(true);
          }
        })
        .catch(error => Promise.reject("ERROR al eliminar el cambio de la designación " + this.idDesignacion.toString() + ": " + error));
    }

    public Guardar(): Promise<PrCambios> {
      let datos: PrCambios = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.guardarCambio(datos)
              .then((resultado: Online.IActas_Cambios_Base) => {
                if (resultado != null && resultado.idCambio > 0) {
                  this.idCambio = resultado.idCambio;
                  return Promise.resolve(this);
                }
                else {
                  return Promise.reject("No se han podido guardar los datos del cambio en el servidor.");
                }
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            // TODO: Realizar versión desconecada
            return Promise.resolve(null);
          }
        })
        .catch(error => Promise.reject("ERROR al guardar el cambio de la designación" + this.idDesignacion.toString() + ": " + error));
    }
  }

  export class ListaPrCambios extends ConMensajes {
    public lista: Array<PrCambios>;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public toastCtrl: ToastController,
      public designacion: PrDesignaciones,
      public idEquipo: number
    ) {
      super(toastCtrl);
      this.lista = [];
    }

    /**
     * Indica si es posible realizar el cambio para la lista de participantes actuales
     * @param entra Dorsal de la persona que va a entrar
     * @param sale Dorsal de la person que va a salir
     * @param participantes Lista de participantes
     */
    public CambioPosible(entra: number, sale: number, participantes: ListaPrParticipacion): boolean {
      let resultado: boolean = true;

      if (participantes != null && participantes.lista != null && participantes.lista.length > 0) {
        // 1.- Los dos dorsales tienes que ser válidos
        let encontradoEntra: boolean = false;
        let encotnradoSale: boolean = false;
        participantes.lista.forEach((valor: PrParticipacion) => {
          if (valor.dorsal == entra) {
            encontradoEntra = true;
          }
          if (valor.dorsal == sale) {
            encotnradoSale = true;
          }
        });

        if (!encontradoEntra || !encotnradoSale) {
          resultado = false;
        }

        // 2.- Se comprueba que no se haya cambiado ya
        participantes.lista.forEach((valor: PrParticipacion) => {
          if (valor.dorsal == sale && this.SeHaCambiado(valor.idAlineado)) {
            resultado = false;
          }
        });

        // 3.- Se comprueba que el que entra, está en la lista de suplentes
        participantes.lista.forEach((valor: PrParticipacion) => {
          if (valor.dorsal == entra && !valor.esSuplente) {
            resultado = false;
          }
        });
      }

      return resultado;
    }

    public CargarCambios(): Promise<boolean> {
      this.lista = [];

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // VERSIÓN ONLINE
            return this.CFutbolActas.cambiosPorDesignacion(this.designacion.urlApi, this.designacion.idDesignacion, this.idEquipo)
              .then((resultado: Array<Online.IActas_Cambios_Base>) => {

                console.log('Resultado de la carga de los cambios', resultado);

                try {
                  // Creación del array
                  resultado.forEach((valor: Online.IActas_Cambios_Base) => {
                    let cambio: PrCambios = new PrCambios(this.CFutbolActas, this.DBService2, this.Persistentes);
                    cambio.urlApi = this.designacion.urlApi;
                    cambio.urlNombre = this.designacion.urlNombre;

                    this.lista.push(Object.assign(cambio, valor));
                  });
                }
                catch (error) {
                  console.log('Error al crear el array de cambios', error);
                }

                return Promise.resolve(true);
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener los cambios."));
          }
          else {
            // VERSIÓN DESCONECTADA
            return Promise.resolve(true);
          }
        })
        .catch(error => Promise.reject("ERROR al obtener los cambios de la designación actual: " + error));
    }

    /**
     * Indica si el jugador ha sido cambiado (se ha producido un cambio en el cual, él ha salido del terreno de juego)
     * @param _idAlineado Identificador del jugador participante (alineado)
     */
    public SeHaCambiado(_idAlineado: number): boolean {
      let resultado: boolean = false;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrCambios) => {
          if (valor.sale == _idAlineado) {
            resultado = true;
          }
        });
      }

      return resultado;
    }

    /**
     * Indica si el jugador (suplente) se encuentra en el terreno de juego en el minuto indicado.
     * Se comprueba si hay un cambio anterior al minuto en el que se incorpore al partido y que no haya un cambio también anterior en el que salga del partido.
     * @param dorsal Dorsal del jugador.
     * @param minuto Minuto a comprobar
     */
    SuplenteEnElTerrenoDeJuego(dorsal: number, minuto: string): boolean {
      let encontradoCambioInicial: boolean = false;
      let encontradoCambioFinal: boolean = false;
      let minutoConvertido: number = parseInt(minuto);

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((cambio: PrCambios) => {
          if (cambio.entra == dorsal && (parseInt(cambio.minuto) <= minutoConvertido || (cambio.descanso && minutoConvertido > 45))) {
            encontradoCambioInicial = true;
          }
          if (cambio.sale == dorsal && parseInt(cambio.minuto) <= minutoConvertido) {
            encontradoCambioFinal = true;
          }
        });
      }

      return encontradoCambioInicial && !encontradoCambioFinal;
    }

    /**
     * Indica si el jugador indicado (titular) se encuentra en el terreno de juego en el minuto indicado.
     * Se comprueba que no exista un cambio que implique a ese jugador antes del minuto indicado.
     * @param dorsal Dorsal del jugador.
     * @param minuto Minuto a comprobar.
     */
    TitularEnElTerrenoDeJuego(dorsal: number, minuto: string): boolean {
      let encontradoCambio: boolean = false;
      let minutoConvertido: number = parseInt(minuto);

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((cambio: PrCambios) => {
          if (cambio.sale == dorsal && (parseInt(cambio.minuto) <= minutoConvertido || (cambio.descanso && minutoConvertido > 45))) {
            encontradoCambio = true;
          }
        });
      }

      return !encontradoCambio;
    }
  }
  // #endregion

  // #region Actas códigos de amonestación
  export class PrCodigoAmonestacion extends pouchdb2.ActasCodigosAmonestacionDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _id: number = 0
    ) {
      super(nombreTabla, _id);
    }
  }

  export class ListaPrCodigoAmonestacion extends ConMensajes {
    public lista: Array<PrCodigoAmonestacion>;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public toastCtrl: ToastController,
      public designacion: PrDesignaciones,
      public idEquipo: number
    ) {
      super(toastCtrl);
      this.lista = [];
    }

    public CargarCodigosAmonestacion(): Promise<boolean> {
      this.lista = [];

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // VERSIÓN ONLINE
            return this.CFutbolActas.codigosAmonestacion(this.designacion.urlApi)
              .then((resultado: Array<Online.IActas_Codigos_Amonestacion>) => {
                // Creación del array
                resultado.forEach((valor: Online.IActas_Codigos_Amonestacion) => {
                  let codigoAmon: PrCodigoAmonestacion = new PrCodigoAmonestacion(this.CFutbolActas, this.DBService2, this.Persistentes);
                  codigoAmon.urlApi = this.designacion.urlApi;
                  codigoAmon.urlNombre = this.designacion.urlNombre;

                  this.lista.push(Object.assign(codigoAmon, valor));
                });

                return Promise.resolve(true);
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener las personas alineables."));
          }
          else {
            // VERSIÓN DESCONECTADA
            // TODO: Realizar la versión desconectada
            return Promise.resolve(true);
          }
        })
        .catch(error => Promise.reject("ERROR al obtener las amonestaciones de la designación actual: " + error));
    }

    /**
     * Devuelve el código de amonestación correspondiente a la doble amonestación.
     */
    public CodigoParaDobleAmonestacion(): PrCodigoAmonestacion {
      let resultado: PrCodigoAmonestacion = null;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrCodigoAmonestacion) => {
          if (valor.Hecho.toUpperCase().indexOf("RECIBIR UNA DOBLE AMONESTACIÓN") >= 0 || valor.Hecho.toUpperCase().indexOf("POR DOBLE AMONESTACIÓN") >= 0) {
            resultado = valor;
          }
        });
      }

      return resultado;
    }

    /**
     * Devuelve el hecho asociado con el código de amonestación cuyo número es pasado como parámetro
     * @param codigo Código a buscar
     */
    public Hecho(codigo: number): string {
      let resultado: string = "";

      if (this.lista.length > 0 && codigo > 0) {
        this.lista.forEach((valor: PrCodigoAmonestacion) => {
          if (valor.Codigo == codigo) {
            resultado = valor.Hecho;
          }
        });
      }

      return resultado;
    }

    /**
     * Indica si el código pasado como parámetro, es una amonestación
     * @param codigo Código a buscar
     */
    public EsAmonestacion(codigo: number): boolean {
      let resultado: boolean = false;

      if (this.lista.length > 0) {
        this.lista.forEach((valor: PrCodigoAmonestacion) => {
          if (codigo == valor.Codigo && !valor.EsExpulsion) {
            resultado = true;
          }
        });
      }

      return resultado;
    }

    /**
     * Indica si el código pasado como parámetro, es una expulsión
     * @param codigo Código a buscar
     */
    public EsExpulsion(codigo: number): boolean {
      let resultado: boolean = false;

      if (this.lista.length > 0) {
        this.lista.forEach((valor: PrCodigoAmonestacion) => {
          if (codigo == valor.Codigo && valor.EsExpulsion) {
            resultado = true;
          }
        });
      }

      return resultado;
    }
  }
  // #endregion

  // #region ActasConfirmacionAlineacion
  export class PrConfirmacionAlineacion extends pouchdb2.ActasConfirmacionDB implements iProxy {
    public idEquipo: number;
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _idDesignacion: number = 0,
      _idEquipo: number = 0
    ) {
      super(nombreTabla, _idDesignacion);
      this.idEquipo = _idEquipo;
    }
  }
  // #endregion

  // #region ActasCustodia

  export class PrActasCustodia extends pouchdb2.ActasCustodiaDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _id: number = 0
    ) {
      super(nombreTabla, _id);
    }

    /**
     * Obtiene los datos de la custodia asociada con la designación actual.
     * @param idDesignacion Identificador de la designación
     */
    public CustodiaPorDesignacion(urlBase: string, idDesignacion: number): Promise<PrActasCustodia> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.custodiaPorDesignacion(urlBase, idDesignacion)
              .then((resultado: Online.IActa_Custodia) => {
                return Promise.resolve(Object.assign(new PrActasCustodia(this.CFutbolActas, this.DBService2, this.Persistentes), resultado));
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener los datos de la custodia (ACTAS_CUSTODIA)."));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.Actas_Custodia(idDesignacion)
              .then((resultado: pouchdb2.ActasCustodiaDB) => {
                return Promise.resolve(<PrActasCustodia>resultado);
              })
              .catch(error => Promise.reject("No se han podido recuperar la custodia desde de la BD local."));
          }
        })
        .catch(error => Promise.reject("ERROR al obtener los datos de la custodia de la designación actual: " + error));
    }

    /**
     * Indica si la custodia está en el estado inicial
     */
    public EsEstadoInicial(): boolean {
      let resultado: boolean = false;

      if (this.id > 0 && this.idDesignacion > 0 && !this.entregada && !this.renuncia && this.sinIncidencias) {
        resultado = true;
      }

      return resultado;
    }

    /**
     * Guarda la información de la custodia del acta actual.
     */
    public Guardar(actualizarFechaEntrega: boolean): Promise<PrActasCustodia> {
      let datos: PrActasCustodia = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.guardarCustodia(datos, actualizarFechaEntrega)
              .then((resultado: Online.IActa_Custodia) => {
                if (resultado != null && resultado.id > 0) {
                  this.id = resultado.id;
                  return Promise.resolve(Object.assign(new PrActasCustodia(this.CFutbolActas, this.DBService2, this.Persistentes), resultado));
                }
                else {
                  return Promise.reject("No se han podido guardar la custodia del acta en el servidor.");
                }
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.Actas_Custodia_Guardar(datos)
              .then((resultado: pouchdb2.ActasCustodiaDB) => {
                if (resultado != null) {
                  this.id = resultado.id;
                  return Promise.resolve(<PrActasCustodia>resultado);
                }
                else {
                  return Promise.reject("No se han podido guardar la custodia del acta en la BD Local.");
                }
              })
              .catch(error => Promise.reject("El guardado en la BD Local ha devuelto el error " + error));
          }
        })
        .catch(error => Promise.reject("ERROR al guardar la custodia de la designación " + this.idDesignacion.toString() + ": " + error));
    }

    /**
     * Indica si por los datos almacenados en la custodia, el dispositivo no ha sido recibido (ha sido entregado en custodia, pero no se ha devuelto)
     */
    public NoHaSidoRecibida(): boolean {
      if (!this.renuncia && this.entregada && !this.recogida) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  // #endregion

  // #region ActasDerechos
  export class PrActasDerechos extends pouchdb2.ActasDerechosDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public designacion: PrDesignaciones,
      nombreTabla: string = "",
      _idDesignacion: number = 0
    ) {
      super(nombreTabla, _idDesignacion);
    }

    /**
     * Carga los datos de los derechos relacionados con la designación
     */
    public Cargar(): Promise<PrActasDerechos> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.derechosArbitrales(this.designacion.urlApi, this.designacion.idDesignacion)
              .then((resultado: Online.IActa_Derechos) => {
                let datos: PrActasDerechos = Object.assign(new PrActasDerechos(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion), resultado);

                return Promise.resolve(datos);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            return Promise.resolve(null);
          }
        })
        .catch(error => Promise.reject("ERROR al obtener los otros datos de un acta de una designación: " + error));
    }

    /**
     * Comprueba si se dan las condiciones para marcar como pago efectuado
     */
    private ComprobarPagoRealizado(idEquipo: number, disponible: number): boolean {
      if (disponible >= this.Total(idEquipo)) {
        if (this.designacion.EquipoLocal(idEquipo) && (this.abonaTarifaL || this.abonaOtrosL)) {
          this.pagoRealizadoL = true;
        }
        else if (!this.designacion.EquipoLocal(idEquipo) && (this.abonaTarifaV || this.abonaOtrosL)) {
          this.pagoRealizadoV = true;
        }
        return true;
      }
      else {
        return false;
      }
    }

    /**
     * Devuelve el saldo disponible del equipo
     */
    public Disponible(idEquipo: number): Promise<number> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.saldoDisponible(this.designacion.urlApi, idEquipo)
              .then((resultado: number) => {
                return Promise.resolve(resultado);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            return Promise.resolve(0);
          }
        })
        .catch(error => Promise.reject("ERROR al obtener el saldo disponibe de un equipo: " + error));
    }

    /**
     * Guarda la información de los derechos arbitrales.
     */
    public Guardar(idEquipo: number): Promise<PrActasDerechos> {
      let noTieneSaldo: boolean = false;
      let datos: PrActasDerechos;

      // Se comprueba si el club (equipo) tiene saldo disponible para realizar el pago
      return this.Disponible(idEquipo)
        .then((resultado: number) => {

          // Antes de guardar los datos, hay que comprobar si se han establecido los pagos
          if (!this.ComprobarPagoRealizado(idEquipo, resultado)) {
            // El club no tiene saldo disponible para abonar los derechos arbitrales
            if (this.designacion.EquipoLocal(idEquipo)) {
              this.abonaTarifaL = false;
              this.abonaOtrosL = false;
              this.pagoRealizadoL = true;
            }
            else {
              this.abonaTarifaV = false;
              this.abonaOtrosV = false;
              this.pagoRealizadoV = true;
            }
            noTieneSaldo = true;
          }
          return this.Persistentes.GetConfiguracion();
        })
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            datos = Object.assign({}, this);

            datos.CFutbolActas = null;
            datos.DBService2 = null;
            datos.Persistentes = null;
            datos.designacion = null;
            datos.urlApi = this.designacion.urlApi;
            datos.urlNombre = this.designacion.urlNombre;

            // Versión ONLINE
            return this.CFutbolActas.guardarDerechos(datos)
              .then((resultado: Online.IActa_Derechos) => {
                if (resultado != null && resultado.idDerechos > 0) {
                  this.idDerechos = resultado.idDerechos;

                  if (noTieneSaldo) {
                    return Promise.reject("El club no dispone de suficiente saldo para realizar el abono de los derechos arbitrales. Se ha guardado este hecho en esta designación, para informar de los derechos no abonados.");
                  }
                  else {
                    return Promise.resolve(this);
                  }
                }
                else {
                  return Promise.reject("No se han podido guardar los datos relacionados con los derechos arbitrales en el servidor.");
                }
              })
              .catch(error => Promise.reject(error));
          }
          else {
            // Versión DESCONECTADA
            // TODO: Realizar versión desconecada
            return Promise.resolve(null);
          }
        })
        .catch(error => Promise.reject(error));
    }

    /**
     * Importe abonado por el club
     */
    public ImporteAbonado(idEquipo: number): number {
      let resultado: number = 0;

      if (this.designacion.EquipoLocal(idEquipo) && this.pagoRealizadoL) {
        if (this.abonaTarifaL) {
          resultado += this.tarifaL;
        }
        if (this.abonaOtrosL) {
          resultado += this.transporteL + this.dietasL + this.avionL + this.otrosL;
        }
      }
      else if (!this.designacion.EquipoLocal(idEquipo) && this.pagoRealizadoV) {
        if (this.abonaTarifaV) {
          resultado += this.tarifaV;
        }
        if (this.abonaOtrosV) {
          resultado += this.transporteV + this.dietasV + this.avionV + this.otrosV;
        }
      }

      return resultado;
    }

    /**
     * Comprueba si el equipo no ha abonado los derechos, porque el sistema no le ha detectado saldo disponible
     * @param idEquipo Identificador del equipo
     */
    public NoAbona(idEquipo: number): boolean {
      let resultado: boolean = false;

      if ((this.designacion.EquipoLocal(idEquipo) && this.pagoRealizadoL && !this.abonaTarifaL && !this.abonaOtrosL) ||
        (!this.designacion.EquipoLocal(idEquipo) && this.pagoRealizadoV && !this.abonaTarifaV && !this.abonaOtrosV)) {
        resultado = true;
      }

      return resultado;
    }

    /**
     * Indica si ya se ha marcado el pago como realizado
     */
    public PagoRealizado(idEquipo: number): boolean {
      if ((this.designacion.EquipoLocal(idEquipo) && this.pagoRealizadoL) || (!this.designacion.EquipoLocal(idEquipo) && this.pagoRealizadoV)) {
        return true;
      }
      else {
        return false;
      }
    }

    /**
     * Devuelve el importe total que se debe abonar por el equipo actual.
     */
    public Total(idEquipo): number {
      if (this.designacion.EquipoLocal(idEquipo)) {
        return this.tarifaL + this.transporteL + this.avionL + this.dietasL + this.otrosL;
      }
      else {
        return this.tarifaV + this.transporteV + this.avionV + this.dietasV + this.otrosV;
      }
    }
  }
  // #endregion

  // #region ActasFutbolSala
  export class PrFutbolSala extends pouchdb2.ActasFutbolSalaDB implements iProxy {

    public faltas1Parte: number = 0;
    public faltas2Parte: number = 0;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public designacion: PrDesignaciones,
      public idEquipo: number,
      nombreTabla: string = "",
      _idRegistro: number = 0
    ) {
      super(nombreTabla, _idRegistro);
    }

    public Cargar(): Promise<PrFutbolSala> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.informacionFutbolSala(this.designacion.urlApi, this.designacion.idDesignacion)
              .then((resultado: Online.IActa_FutbolSala) => {
                let datos: PrFutbolSala = Object.assign(new PrFutbolSala(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.idEquipo), resultado);

                if (this.designacion.EquipoLocal(this.idEquipo)) {
                  datos.faltas1Parte = datos.faltasLocal1Parte;
                  datos.faltas2Parte = datos.faltasLocal2Parte;
                }
                else {
                  datos.faltas1Parte = datos.faltasVisitante1Parte;
                  datos.faltas2Parte = datos.faltasVisitante2Parte;
                }

                return Promise.resolve(datos);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            return Promise.resolve(null);
          }
        })
        .catch(error => Promise.reject("ERROR al obtener los otros datos de un acta de una designación: " + error));
    }

    public Guardar(): Promise<PrFutbolSala> {
      let datos: PrFutbolSala = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;
      datos.designacion = null;
      datos.idEquipo = null;
      datos.urlApi = this.designacion.urlApi;
      datos.urlNombre = this.designacion.urlNombre;

      // Actualización de las faltas
      if (this.designacion.EquipoLocal(this.idEquipo)) {
        datos.faltasLocal1Parte = datos.faltas1Parte;
        datos.faltasLocal2Parte = datos.faltas2Parte;
      }
      else {
        datos.faltasVisitante1Parte = datos.faltas1Parte;
        datos.faltasVisitante2Parte = datos.faltas2Parte;
      }

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {

          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.guardarFutbolSala(datos)
              .then((resultado: Online.IActa_FutbolSala) => {
                if (resultado != null && resultado.idRegistro > 0) {
                  this.idRegistro = resultado.idRegistro;
                  return Promise.resolve(this);
                }
                else {
                  return Promise.reject("No se han podido guardar los datos relacionados con la modalidad de fútbol sala en el servidor.");
                }
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            // TODO: Realizar versión desconecada
            return Promise.resolve(null);
          }
        })
        .catch(error => Promise.reject("ERROR al guardar los datos de la modilidad de fútbol sala " + this.idDesignacion.toString() + ": " + error));
    }
  }
  // #endregion

  // #region ActasGoles
  export class PrGoles extends pouchdb2.ActasGolesDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _idDesignacion: number = 0,
      _idGol: number = 0
    ) {
      super(nombreTabla, _idGol);
    }

    public Eliminar(): Promise<boolean> {
      let datos: PrGoles = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.eliminarGol(datos)
              .then((resultado: boolean) => {
                return Promise.resolve(resultado);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            // TODO: Realizar versión desconecada
            return Promise.resolve(true);
          }
        })
        .catch(error => Promise.reject("ERROR al eliminar el gol de la designación " + this.idDesignacion.toString() + ": " + error));
    }

    public Guardar(): Promise<PrGoles> {
      let datos: PrGoles = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;


      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.guardarGol(datos)
              .then((resultado: Online.IActa_Goles_Base) => {
                if (resultado != null && resultado.idGol > 0) {
                  this.idGol = resultado.idGol;
                  return Promise.resolve(this);
                }
                else {
                  return Promise.reject("No se han podido guardar los datos del gol en el servidor.");
                }
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            // TODO: Realizar versión desconecada
            return Promise.resolve(null);
          }
        })
        .catch(error => Promise.reject("ERROR al guardar el gol de la designación" + this.idDesignacion.toString() + ": " + error));
    }
  }

  export class PrGolesConTotal extends PrGoles {
    public total: number;
    public totalPropiaPuerta: number;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public nombreTabla: string = "",
      public _idDesignacion: number = 0,
      public _idGol: number = 0
    ) {
      super(CFutbolActas, DBService2, Persistentes, nombreTabla, _idDesignacion, _idGol);
      this.total = 0;
      this.totalPropiaPuerta = 0;
    }

    public Eliminar(): Promise<boolean> {
      return super.Eliminar();
    }

    public Guardar(): Promise<PrGoles> {
      return super.Guardar();
    }
  }

  export class ListaPrGoles extends ConMensajes {
    public lista: Array<PrGolesConTotal>;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public toastCtrl: ToastController,
      public designacion: PrDesignaciones,
      public idEquipo: number
    ) {
      super(toastCtrl);
      this.lista = [];
    }

    /**
     * Actualiza el resultado que está guardado en los datos persistentes de la designación.
     * @param numeroGoles Número de goles a sumar a o restar
     * @param propiaPuerta Indica si son goles en propia puerta
     */
    private ActualizarResultado(numeroGoles: number, propiaPuerta: boolean): void {
      let golesL: number = this.Persistentes.GetGolesLocal() != undefined ? this.Persistentes.GetGolesLocal() : 0;
      let golesV: number = this.Persistentes.GetGolesVisitante() != undefined ? this.Persistentes.GetGolesVisitante() : 0;

      if (this.designacion.EquipoLocal(this.idEquipo)) {
        if (!propiaPuerta) {
          golesL += numeroGoles;
          this.Persistentes.SetGolesLocal(golesL);
        }
        else {
          golesV += numeroGoles;
          this.Persistentes.SetGolesVisitante(golesV);
        }
      }
      else {
        if (!propiaPuerta) {
          golesV += numeroGoles;
          this.Persistentes.SetGolesVisitante(golesV);
        }
        else {
          golesL += numeroGoles;
          this.Persistentes.SetGolesLocal(golesL);
        }
      }
    }

    /**
     * Aumenta en uno la cantidad de goles que ha marcado un jugador
     * @param datos Goles por jugador
     */
    public Aumentar(datos: PrGolesConTotal): Promise<boolean | void> {
      let nuevo: PrGoles = new PrGoles(this.CFutbolActas, this.DBService2, this.Persistentes);
      nuevo.idGol = 0;
      nuevo._id = "";
      nuevo._rev = "";
      nuevo.idDesignacion = this.designacion.idDesignacion;
      nuevo.idEquipo = this.idEquipo;
      nuevo.idJugador = datos.idJugador;
      nuevo.minuto = "";
      nuevo.minutoExtra = "";
      nuevo.penalty = datos.penalty;
      nuevo.propiaPuerta = datos.propiaPuerta;
      nuevo.type = "";
      nuevo.urlNombre = this.designacion.urlNombre;
      nuevo.urlApi = this.designacion.urlApi;

      return nuevo.Guardar()
        .then((resultado: PrGoles) => {
          let computado: boolean = false;    // Se incluye esta variable, para que no se computen dos veces los goles del mismo jugador.

          this.lista.forEach((valor: PrGolesConTotal) => {
            if (!computado && valor.idJugador == datos.idJugador) {
              if (datos.propiaPuerta) {
                if (valor.totalPropiaPuerta == undefined) {
                  valor.totalPropiaPuerta = 0;
                }
                valor.totalPropiaPuerta += 1;
                computado = true;
              }
              else {
                if (valor.total == undefined) {
                  valor.total = 0;
                }
                valor.total += 1;
                computado = true;
              }
              this.ActualizarResultado(1, valor.propiaPuerta);
            }
          });
          Promise.resolve(Boolean);
        })
        .catch(error => this.Error(error, "ERROR aumentado la cantidad de goles de un jugador"));
    }

    /**
     * Disminuye en uno la cantidad de goles que ha marcado un jugador
     * @param datos Goles por jugador
     */
    public Disminuir(datos: PrGolesConTotal): Promise<boolean | void> {
      return datos.Eliminar()
        .then((resultado: boolean) => {
          this.lista.forEach((valor: PrGolesConTotal, i: number) => {
            if (valor.idJugador == datos.idJugador) {

              if (valor.propiaPuerta) {
                valor.totalPropiaPuerta -= 1;
              }
              else {
                valor.total -= 1;
              }

              if ((valor.total == undefined || valor.total == 0) && (valor.totalPropiaPuerta == undefined || valor.totalPropiaPuerta == 0)) {
                this.lista.splice(i, 1);
              }

              this.ActualizarResultado(-1, valor.propiaPuerta);
            }
          });
          return Promise.resolve(true);
        })
        .catch(error => this.Error(error, "ERROR disminuyendo la cantidad de goles de un jugador"));
    }

    /**
     * Incluye en la lista actual, el gol pasado como parámetro
     * @param datos Datos del goleador a incluir en la lista de goleadores (PrGoles)
     */
    public Incluir(datos: PrGolesConTotal): void {
      let encontrado: boolean = false;

      this.lista.forEach((valor: PrGolesConTotal) => {
        if (!encontrado && valor.idJugador == datos.idJugador) {
          encontrado = true;

          if (datos.propiaPuerta) {
            valor.totalPropiaPuerta += 1;
          }
          else {
            valor.total += 1;
          }
        }
      });

      if (!encontrado) {
        let nuevo: PrGolesConTotal = <PrGolesConTotal>datos;
        if (datos.propiaPuerta) {
          nuevo.totalPropiaPuerta = 1;
        }
        else {
          nuevo.total = 1;
        }
        this.lista.push(nuevo);
      }
    }

    /**
     * Añade un nuevo goleador en la lista de goleadores. Si ya existe, añade un gol en su lista de goles
     * @param participante Datos del participante
     * @param propiaPuerta Indica que es un gol en propia puerta
     * @param penalty Indica si es un gol de penalty
     */
    public IncluirGoleador(participante: PrParticipacion, propiaPuerta: boolean = false, penalty: boolean = false): Promise<boolean | void> {
      let nuevo: PrGoles = new PrGoles(this.CFutbolActas, this.DBService2, this.Persistentes);
      nuevo.idDesignacion = this.designacion.idDesignacion;
      nuevo.idEquipo = this.idEquipo;
      nuevo.idJugador = participante.idRegistro;
      nuevo.propiaPuerta = propiaPuerta;
      nuevo.penalty = penalty;
      nuevo.minuto = "";
      nuevo.minutoExtra = "";
      nuevo._id = "";
      nuevo._rev = "";
      nuevo.type = "";
      nuevo.idGol = 0;
      nuevo.urlApi = this.designacion.urlApi;
      nuevo.urlNombre = this.designacion.urlNombre;

      return nuevo.Guardar()
        .then((resultado: PrGoles) => {
          let encontrado: boolean = false;

          this.lista.forEach((valor: PrGolesConTotal) => {
            if (valor.idJugador == resultado.idJugador) {
              if (propiaPuerta) {
                valor.totalPropiaPuerta += 1;
              }
              else {
                valor.total += 1;
              }
              encontrado = true;
            }
          });
          if (!encontrado) {
            let nuevoGoleador: PrGolesConTotal = <PrGolesConTotal>resultado;
            if (propiaPuerta) {
              nuevoGoleador.totalPropiaPuerta = 1;
            }
            else {
              nuevoGoleador.total = 1;
            }
            this.lista.push(nuevoGoleador);
          }
          this.ActualizarResultado(1, propiaPuerta);
          return Promise.resolve(true);
        })
        .catch(error => this.Error(error, "ERROR incluyen un nuevo goleador en la lista de goleadores"));
    }

    public CargarGoles(): Promise<boolean> {
      this.lista = [];

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // VERSIÓN ONLINE
            return this.CFutbolActas.golesPorDesignacion(this.designacion.urlApi, this.designacion.idDesignacion)
              .then((resultado: Array<Online.IActa_Goles_Base>) => {
                // Creación del array
                resultado.forEach((valor: Online.IActa_Goles_Base) => {
                  if (valor.idEquipo == this.idEquipo) {
                    this.Incluir(Object.assign(new PrGolesConTotal(this.CFutbolActas, this.DBService2, this.Persistentes), valor));
                  }
                });

                return Promise.resolve(true);
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener los goles."));
          }
          else {
            // VERSIÓN DESCONECTADA
            return Promise.resolve(true);
          }
        })
        .catch(error => Promise.reject("ERROR al obtener los goles de la designación actual: " + error));
    }

    /**
     * Devuelve el número total de goles para el participante pasado como parámetro
     * @param idParticipante Identificador del jugador participante
     * @param propiaPuerta  Indica si se desea obtener el total de goles en propia puerta
     */
    public TotalPorParticipante(idParticipante: number, propiaPuerta: boolean = false): number {
      let total: number = 0;

      if (this.lista && this.lista.length > 0) {
        this.lista.forEach((gol: PrGolesConTotal) => {
          if (gol.idJugador == idParticipante) {
            if (propiaPuerta && gol.propiaPuerta) {
              total += gol.totalPropiaPuerta;
            }
            else if (!propiaPuerta && !gol.propiaPuerta) {
              total += gol.total;
            }
          }
        });
      }

      return total;
    }
  }

  export class PrResultado extends ConMensajes implements iProxy {
    public golesLocales: number;
    public golesVisitantes: number;
    private locales: ListaPrGoles;
    private visitantes: ListaPrGoles;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public toastCtrl: ToastController,
      public designacion: PrDesignaciones
    ) {
      super(toastCtrl);
      this.locales = new ListaPrGoles(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.designacion.idLocal);
      this.visitantes = new ListaPrGoles(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.designacion.idVisitante);
    }

    public Obtener(): Promise<boolean | void> {
      this.golesLocales = 0;
      this.golesVisitantes = 0;

      return this.locales.CargarGoles()
        .then((resultado: boolean) => {
          if (this.locales.lista != null && this.locales.lista.length > 0) {
            this.locales.lista.forEach((valor: PrGolesConTotal) => {
              if (!valor.propiaPuerta) {
                this.golesLocales += valor.total;
              }
              else {
                this.golesVisitantes += valor.totalPropiaPuerta;
              }
            });
          }

          return this.visitantes.CargarGoles();
        })
        .then((resultado: boolean) => {
          if (this.visitantes.lista != null && this.visitantes.lista.length > 0) {
            this.visitantes.lista.forEach((valor: PrGolesConTotal) => {
              if (!valor.propiaPuerta) {
                this.golesVisitantes += valor.total;
              }
              else {
                this.golesLocales += valor.totalPropiaPuerta;
              }
            });
          }
          return Promise.resolve(true);
        })
        .catch(error => this.Error(error, "ERROR obteniendo el resultado del partido."));
    }
  }
  // #endregion

  // #region ActasOtros
  export class PrActasOtros extends pouchdb2.ActasOtrosDB implements iProxy {

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public Designacion: PrDesignaciones,
      nombreTabla: string = "",
      _idRegistro: number = 0
    ) {
      super(nombreTabla, _idRegistro);
    }

    /**
     * Comprueba si la propiedad Designación tiene datos, para quitarlos para corregir un posible error de dependencia circular (Persistentes). También, comprueba si se ha establecido correctamente los valores para la dirección y nombre de la API.
     * @param datos Datos actuales (PrActasOtros)
     */
    private EvitarDependenciaCircular(datos: PrActasOtros): PrActasOtros {
      if (datos.Designacion != null && datos.Designacion.Persistentes != null) {
        datos.Designacion.CFutbolActas = null;
        datos.Designacion.DBService2 = null;
        datos.Designacion.Persistentes = null;
      }

      if ((datos.urlApi == undefined || datos.urlApi == "") && this.Designacion.urlApi != null && this.Designacion.urlApi.length > 0) {
        datos.urlApi = this.Designacion.urlApi;
        datos.urlNombre = this.Designacion.urlNombre;
      }
      return datos;
    }

    public ListaMotivosSuspension(): Promise<string[]> {
      return this.CFutbolActas.listaMotivosSuspension()
        .then((resultado: any) => {
          return Promise.resolve(resultado);
        })
        .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
    }

    /**
     * Guarda la información de otros datos del acta actual.
     */
    public Guardar(): Promise<boolean> {
      let datos: PrActasOtros = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      datos = this.EvitarDependenciaCircular(datos);

      return this.CFutbolActas.guardarOtros(datos)
        .then((resultado: Online.IActasOtros) => {
          if (resultado != null && resultado.idRegistro > 0) {
            this.idRegistro = resultado.idRegistro;
            return Promise.resolve(true);
          }
          else {
            return Promise.reject("No se han podido guardar los otros datos del acta en el servidor.");
          }
        })
        .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
    }
  }
  // #endregion

  // #region Arbitros
  export class PrArbitro extends pouchdb2.ArbitroBasicoDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _idArbitro: number = 0
    ) {
      super(nombreTabla, _idArbitro);
    }

    /**
     * Realiza la validación del usuario en el sistema
     * @param usuario Nombre del usuario
     * @param contrasenia Contraseña del usuario
     */
    public Validar(usuario: string, contrasenia: string): Promise<boolean> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          // Versión ONLINE
          if (resultado.online) {
            return this.CFutbolActas.validacion(usuario, contrasenia)
              .then((resultado: Online.ArbitroBasico) => {
                console.log(resultado);
                if (resultado != null && resultado.idArbitro > 0) {
                  this.Persistentes.SetArbitro(resultado);
                  return Promise.resolve(true);
                }
                else {
                  return Promise.reject("Usuario no encontrado. Los datos que ha indicado, no corresponden con ningún usuario registrado en el sistema.");
                }
              })
              .catch(error => {
                return Promise.reject("ERROR en la validación en la versión ONLINE: " + error);
              });
          }
          // Versión DESCONECTADA
          else {
            return this.DBService2.Arbitro_PorUsuarioYContrasenia(usuario, contrasenia)
              .then((resultado: pouchdb2.ArbitroBasicoDB) => {
                if (resultado != null && resultado.idArbitro > 0) {
                  this.Persistentes.SetArbitro(resultado);
                  return Promise.resolve(true);
                }
                else {
                  return this.CFutbolActas.validacion(usuario, contrasenia)
                    .then((resultado: Online.ArbitroBasico) => {
                      if (resultado != null && resultado.idArbitro > 0) {
                        this.DBService2.Arbitro_Guardar(<pouchdb2.ArbitroBasicoDB>resultado)
                          .then((resultado: pouchdb2.ArbitroBasicoDB) => {
                            this.Persistentes.SetArbitro(resultado);
                            return Promise.resolve(true);
                          })
                          .catch(error => {
                            return Promise.reject("No se han podido guardar los datos del usuario validado.");
                          });
                      }
                      else {
                        return Promise.reject("Usuario no encontrado. Los datos que ha indicado, no corresponden con ningún usuario registrado en el sistema.");
                      }
                    })
                    .catch(error => {
                      return Promise.reject("Al intentar validar el usuario contra el servidor y guardando sus datos en la BD local.");
                    });
                }
              })
              .catch(error => {
                return Promise.reject("No se ha podido realizar la validación. Compruebe que los datos son correctos y si es la primera vez que accede, que tiene conexión a Internet.");
              });
          }
        })
        .catch(error => Promise.reject("ERROR en la validación: " + error));
    }
  }
  // #endregion

  // #region Configuraciones
  export class PrConfiguracion extends pouchdb2.ActasConfiguracionesDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _idDesignacion: number = 0
    ) {
      super(nombreTabla, _idDesignacion);
    }
  }
  // #endregion

  // #region Designaciones
  export class PrDesignaciones extends pouchdb2.DesignacionDB implements iProxy {
    public ConfirmacionLocal: PrConfirmacionAlineacion;
    public ConfirmacionVisitante: PrConfirmacionAlineacion;
    public Configuracion: PrConfiguracion;
    public Derechos: PrActasDerechos;
    public OtrosDatos: PrActasOtros;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _idDesignacion: number = 0
    ) {
      super(nombreTabla, _idDesignacion);
    }

    // #region Métodos principales

    public ActualizarArbitros(numeroArbitro2: number | null, numeroAsistente1: number | null, numeroAsistente2: number | null, numeroAsistente3: number | null, numeroAsistente4: number | null, numeroCronometrador: number | null): Promise<PrDesignaciones> {
      let datos: PrDesignaciones = Object.assign({}, this);

      datos.ConfirmacionLocal = null;
      datos.ConfirmacionVisitante = null;
      datos.Configuracion = null;
      datos.Derechos = null;
      datos.OtrosDatos = null;
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.CFutbolActas.actualizarColegiados(datos, numeroArbitro2, numeroAsistente1, numeroAsistente2, numeroAsistente3, numeroAsistente4, numeroCronometrador)
        .then((resultado: Online.IDesignacion) => {
          return Object.assign(new PrDesignaciones(this.CFutbolActas, this.DBService2, this.Persistentes), resultado);
        })
        .catch(error => Promise.reject("El servidor ha devuelto un error al guardar los datos de los colegiados."));
    }

    /**
     * Indica la clase CSS que debería tener la designación actual
     */
    public ClaseEstado(): string {
      let clases: string = (this.OtrosDatos != null && this.OtrosDatos.estadoProvisional != undefined)
        ? 'recuadro recuadro--' + this.OtrosDatos.estadoProvisional.toLowerCase().replace(" ", "-")
        : "";

      if (this.EsExterna()) {
        clases += " externa";
      }

      return clases;
    }

    /**
     * Lista de designaciones que tiene asociado un árbitro. Además de cargar la información de la designación, también carga otros datos: Actas_Otros, Actas_Configuraciones, Actas_Derechos, Actas_ConfirmacionAlineacion.
     * @param idArbitro Identificador del árbitro
     */
    public DesignacionesPorUsuario(idArbitro: number): Promise<Array<PrDesignaciones>> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.designacionesPorArbitro(idArbitro)
              .then((resultado: Array<Online.Designacion>) => {
                let aux: Array<PrDesignaciones> = [];
                let promesas: Array<Promise<PrDesignaciones>> = [];

                console.log("Lista de designaciones obtenida");
                console.log(resultado);

                // Creación del array con todas las designaciones
                resultado.forEach((valor: Online.Designacion) => {
                  aux.push(Object.assign(new PrDesignaciones(this.CFutbolActas, this.DBService2, this.Persistentes), valor));
                });

                // Obtención de los otros valores de las actas relacionadas (Actas_Otros)
                aux.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarOtros(valor));
                });

                return Promise.all(promesas);
              })
              .then((resultado: Array<PrDesignaciones>) => {
                let promesas: Array<Promise<PrDesignaciones>> = [];

                // Obtención de las configuraciones de cada designación (Actas_Configuraciones)
                resultado.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarConfiguracion(valor));
                });

                return Promise.all(promesas);
              })
              .then((resultado: Array<PrDesignaciones>) => {
                let promesas: Array<Promise<PrDesignaciones>> = [];

                // Obtención de los derechos arbitrales de cada designación (Actas_Derechos)
                resultado.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarDerechos(valor));
                });

                return Promise.all(promesas);
              })
              .then((resultado: Array<PrDesignaciones>) => {
                let promesas: Array<Promise<PrDesignaciones>> = [];

                // Obtención de la confirmación de alineación del equipo local (Actas_ConfirmarAlineacion)
                resultado.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarConfirmacion(valor, true));
                });

                return Promise.all(promesas);
              })
              .then((resultado: Array<PrDesignaciones>) => {
                let promesas: Array<Promise<PrDesignaciones>> = [];

                // Obtención de la confirmación de alineación del equipo visitante (Actas_ConfirmarAlineacion)
                resultado.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarConfirmacion(valor, false));
                });

                return Promise.all(promesas);
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener las designaciones relacionadas."));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.Designaciones_PorArbitro(idArbitro)
              .then((resultado: Array<pouchdb2.DesignacionDB>) => {
                let aux: Array<PrDesignaciones> = [];
                let promesas: Array<Promise<PrDesignaciones>> = [];

                // Creación del array con todas las designaciones
                resultado.forEach((valor: pouchdb2.DesignacionDB) => {
                  aux.push(<PrDesignaciones>valor);
                });

                // Obtención de los otros valores de las actas relacionadas (Actas_Otros)
                aux.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarOtros(valor));
                });

                return Promise.all(promesas);
              })
              .then((resultado: Array<PrDesignaciones>) => {
                let promesas: Array<Promise<PrDesignaciones>> = [];

                // Obtención de las configuraciones de cada designación (Actas_Configuraciones)
                resultado.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarConfiguracion(valor));
                });

                return Promise.all(promesas);
              })
              .then((resultado: Array<PrDesignaciones>) => {
                let promesas: Array<Promise<PrDesignaciones>> = [];

                // Obtención de los derechos arbitrales de cada designación (Actas_Derechos)
                resultado.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarDerechos(valor));
                });

                return Promise.all(promesas);
              })
              .then((resultado: Array<PrDesignaciones>) => {
                let promesas: Array<Promise<PrDesignaciones>> = [];

                // Obtención de la confirmación de alineación del equipo local (Actas_ConfirmarAlineacion)
                resultado.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarConfirmacion(valor, true));
                });

                return Promise.all(promesas);
              })
              .then((resultado: Array<PrDesignaciones>) => {
                let promesas: Array<Promise<PrDesignaciones>> = [];

                // Obtención de la confirmación de alineación del equipo visitante (Actas_ConfirmarAlineacion)
                resultado.forEach((valor: PrDesignaciones) => {
                  promesas.push(this.CargarConfirmacion(valor, false));
                });

                return Promise.all(promesas);
              })
              .catch(error => Promise.reject("No se han podido recuperar las designaciones desde de la BD local."));
          }
        })
        .catch(error => Promise.reject("ERROR al obtener las designaciones por usuario: " + error));
    }

    /**
     * Indica si es el equipo local de la designación
     * @param idEquipo Identificador del equipo
     */
    public EquipoLocal(idEquipo: number): boolean {
      return this.idLocal == idEquipo ? true : false;
    }

    /**
     * Indica si es una designación externa
     */
    public EsExterna(): boolean {
      if (this.urlNombre.toUpperCase().indexOf("EXTERNA") >= 0) {
        return true;
      }
      else {
        return false;
      }
    }

    /**
     * Finaliza la designación actual
     */
    public Finalizar(): Promise<boolean> {
      let datos: PrDesignaciones = Object.assign({}, this);

      datos.ConfirmacionLocal = null;
      datos.ConfirmacionVisitante = null;
      datos.Configuracion = null;
      datos.Derechos = null;
      datos.OtrosDatos = null;
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.CFutbolActas.finalizarDesignacion(datos)
        .then((resultado: boolean) => {
          return Promise.resolve(resultado);
        })
        .catch(error => Promise.reject(error));
    }

    // #endregion

    // #region Carga de las propiedades extra de la instancia: Confirmaciones, Configuración, Derechos, Otros datos.

    /**
     * Añade en la designación pasada como parámetro, los datos correspondientes la confirmación de alineación de uno de los dos equipos. Devuelve en forma de Promise la designación con sus datos actualizados.
     * @param designacion Datos de la designación
     * @param local Indica si se quiere obtener la confirmación del equipo local
     */
    private CargarConfirmacion(designacion: PrDesignaciones, local: boolean): Promise<PrDesignaciones> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.confirmacion(designacion.urlApi, designacion.idDesignacion, local ? designacion.idLocal : designacion.idVisitante)
              .then((resultado: Online.IActa_ConfirmarAlineacion) => {
                if (local) {
                  let confirmaLocal: PrConfirmacionAlineacion = new PrConfirmacionAlineacion(this.CFutbolActas, this.DBService2, this.Persistentes);
                  confirmaLocal.urlApi = designacion.urlApi;
                  confirmaLocal.urlNombre = designacion.urlNombre;

                  designacion.ConfirmacionLocal = Object.assign(confirmaLocal, resultado);
                }
                else {
                  let confirmaVisitante: PrConfirmacionAlineacion = new PrConfirmacionAlineacion(this.CFutbolActas, this.DBService2, this.Persistentes);
                  confirmaVisitante.urlApi = designacion.urlApi;
                  confirmaVisitante.urlNombre = designacion.urlNombre;

                  designacion.ConfirmacionVisitante = Object.assign(confirmaVisitante, resultado);
                }
                return Promise.resolve(designacion);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.Actas_ConfirmacionAlineacion(designacion.idDesignacion, local ? designacion.idLocal : designacion.idVisitante)
              .then((resultado: pouchdb2.ActasConfirmacionDB) => {
                if (local) {
                  designacion.ConfirmacionLocal = <PrConfirmacionAlineacion>resultado;
                }
                else {
                  designacion.ConfirmacionVisitante = <PrConfirmacionAlineacion>resultado;
                }
                return Promise.resolve(designacion);
              })
              .catch(error => Promise.reject("La obtención de los otros datos desde la BD local ha devuelto el error " + error));
          }
        })
        .catch(error => Promise.reject("ERROR al obtener los otros datos de un acta de una designación: " + error));
    }

    /**
     * Añade en la designación pasada como parámetro, los datos correspondientes a las configuraciones relacionadas. Devuelve en forma de Promise la designación con sus datos actualizados.
     * @param designacion Datos de la designación
     */
    private CargarConfiguracion(designacion: PrDesignaciones): Promise<PrDesignaciones> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.configuraciones(designacion.urlApi, designacion.idDesignacion)
              .then((resultado: Online.IActa_Configuraciones) => {
                designacion.Configuracion = Object.assign(new PrConfiguracion(this.CFutbolActas, this.DBService2, this.Persistentes), resultado);
                return Promise.resolve(designacion);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.Actas_Configuraciones(designacion.idDesignacion)
              .then((resultado: pouchdb2.ActasConfiguracionesDB) => {
                designacion.Configuracion = <PrConfiguracion>resultado;
                return Promise.resolve(designacion);
              })
              .catch(error => Promise.reject("La obtención de los otros datos desde la BD local ha devuelto el error " + error));
          }
        })
        .catch(error => Promise.reject("ERROR al obtener los otros datos de un acta de una designación: " + error));
    }

    /**
     * Añade en la designación pasada como parámetro, los datos correspondientes a los derechos arbitrales relacionados. Devuelve en forma de Promise la designación con sus datos actualizados.
     * @param designacion Datos de la designación
     */
    private CargarDerechos(designacion: PrDesignaciones): Promise<PrDesignaciones> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.derechosArbitrales(designacion.urlApi, designacion.idDesignacion)
              .then((resultado: Online.IActa_Derechos) => {
                designacion.Derechos = Object.assign(new PrActasDerechos(this.CFutbolActas, this.DBService2, this.Persistentes, designacion), resultado);
                return Promise.resolve(designacion);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.Actas_Derechos(designacion.idDesignacion)
              .then((resultado: pouchdb2.ActasDerechosDB) => {
                designacion.Derechos = <PrActasDerechos>resultado;
                return Promise.resolve(designacion);
              })
              .catch(error => Promise.reject("La obtención de los otros datos desde la BD local ha devuelto el error " + error));
          }
        })
        .catch(error => Promise.reject("ERROR al obtener los otros datos de un acta de una designación: " + error));
    }

    /**
     * Añade en la designación pasada como parámetro, los datos correspondientes a "Actas_Otros" relacionados. Devuelve en forma de Promise la designación con sus datos
     * @param designacion Datos de la designación
     */
    private CargarOtros(designacion: PrDesignaciones): Promise<PrDesignaciones> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.otros(designacion.urlApi, designacion.idDesignacion)
              .then((resultado: Online.IActasOtros) => {
                designacion.OtrosDatos = Object.assign(new PrActasOtros(this.CFutbolActas, this.DBService2, this.Persistentes, this), resultado);
                return Promise.resolve(designacion);
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.Actas_Otros_PorDesignacion(designacion.idDesignacion)
              .then((resultado: pouchdb2.ActasOtrosDB) => {
                designacion.OtrosDatos = <PrActasOtros>resultado;
                return Promise.resolve(designacion);
              })
              .catch(error => Promise.reject("La obtención de los otros datos desde la BD local ha devuelto el error " + error));
          }
        })
        .catch(error => Promise.reject("ERROR al obtener los otros datos de un acta de una designación: " + error));
    }

    // #endregion
  }
  // #endregion

  // #region Personas alineables

  export class PrPersonaAlineable extends pouchdb2.PersonasAlineablesDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _idDesignacion: number = 0,
      _idPersona: number = 0,
      _idEquipo: number = 0
    ) {
      super(nombreTabla, _idDesignacion, _idPersona, _idEquipo);
    }

    public Eliminar(idDesignacion: number): Promise<boolean> {
      let datos: PrPersonaAlineable = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            return this.CFutbolActas.eliminarAlineado(datos, idDesignacion)
              .then((resultado: boolean) => {
                if (resultado) {
                  return Promise.resolve(resultado);
                }
                else {
                  return Promise.reject("No se han podido eliminar los datos de la persona en el servidor.");
                }
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            return Promise.resolve(true);
          }
        })
        .catch(error => Promise.reject("ERROR al eliminar los datos de una persona: " + error));
    }

    public Guardar(idDesignacion: number): Promise<PrPersonaAlineable> {
      let datos: PrPersonaAlineable = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            console.log("Datos del alineable a guardar", datos);
            // Versión ONLINE
            return this.CFutbolActas.guardarAlineado(datos, idDesignacion)
              .then((resultado: Online.IPersonaAlineable) => {
                if (resultado != null && resultado.idAlineado > 0) {
                  this.idAlineado = this.idAlineado;
                  this.idPersona = this.idPersona;
                  return Promise.resolve(this);
                }
                else {
                  return Promise.reject("No se han podido guardar los datos de la persona en el servidor.");
                }
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            // Versión DESCONECTADA
            // TODO: Realizar versión desconecada
            return Promise.resolve(null);
          }
        })
        .catch(error => Promise.reject("ERROR al guardar la amonestación de la designación" + this.idDesignacion.toString() + ": " + error));
    }

    /**
     * Indica si la persona es menor de edad
     * @returns Devuelve true si la persona es menor de edad, en caso contrario, devuelve false.
     */
    public MenorEdad(): boolean {
      let fnac: Date = moment(this.fechaNacimiento, 'DD/MM/YYYY').toDate();
      let fechaActual: Date = moment().toDate();

      let edad: number = fechaActual.getFullYear() - fnac.getFullYear();
      let mes: number = fechaActual.getMonth() - fnac.getMonth();

      if (mes < 0 || (mes === 0 && fechaActual.getDate() < fnac.getDate())) {
        edad--;
      }

      return (edad < 18);
    }

    // #region Métodos principales
    public PersonasAlineablesPorEquipoYFecha(designacion: PrDesignaciones, esLocal: boolean): Promise<Array<PrPersonaAlineable>> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.alineablesPorEquipo(designacion.urlApi, esLocal ? designacion.idLocal : designacion.idVisitante, designacion.idDesignacion, designacion.fecha)
              .then((resultado: Array<Online.IPersonaAlineable>) => {
                let aux: Array<PrPersonaAlineable> = [];

                // Creación del array con todas las personas alineables
                resultado.forEach((valor: Online.PersonaAlineable) => {
                  aux.push(Object.assign(new PrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes), valor));
                });

                return Promise.all(aux);
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener las personas alineables."));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.PersonasAlineables_PorDesignacionYEquipo(designacion.idDesignacion, esLocal ? designacion.idLocal : designacion.idVisitante)
              .then((resultado: pouchdb2.PersonasAlineablesDB[]) => {
                let aux: Array<PrPersonaAlineable> = [];

                // Creación del array con todas las designaciones
                resultado.forEach((valor: pouchdb2.PersonasAlineablesDB) => {
                  aux.push(<PrPersonaAlineable>valor);
                });

                return Promise.resolve(aux);
              })
              .catch(error => Promise.reject("No se han podido recuperar las personas alineables desde de la BD local."));
          }
        })
        .catch(error => Promise.reject("ERROR al obtener las personas alineables por equipo y fecha: " + error));
    }

    public PersonaInhabilitada(): Promise<boolean> {
      let datos: PrPersonaAlineable = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            return this.CFutbolActas.personaInhabilitada(datos);
          }
          else {
            return Promise.resolve(false);
          }
        })
        .catch(error => Promise.reject("ERROR al consultar la inhabilitación de una persona: " + error));
    }

    public SituacionesPorDNI(urlBase: string, dni: string): Promise<Array<PrPersonaAlineable>> {
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            return this.CFutbolActas.situacionesAlineablesPorDNI(urlBase, dni)
              .then((resultado: Array<Online.IPersonaAlineable>) => {
                let aux: Array<PrPersonaAlineable> = [];

                resultado.forEach((valor: Online.IPersonaAlineable) => {
                  aux.push(Object.assign(new PrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes), valor));
                });

                return Promise.all(aux);
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener la lista de situaciones por dni."));
          }
          else {
            // TODO: Hacer la versión desconectada.
            return Promise.resolve(null);
          }
        })
        .catch(error => Promise.reject("ERROR al consultar las situaciones alineables de un DNI: " + error));
    }
    // #endregion
  }

  export class ListaPrPersonaAlineable {
    public lista: Array<PrPersonaAlineable>;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public designacion: PrDesignaciones,
      public idEquipo: number
    ) {
      this.lista = [];
    }

    /**
     * Obtiene la persona alineable que está en la lista de alineables y que coincide con el identificador indicado
     * @param identificador Identificador (DNI) de la persona
     */
    public AlineablePorIdentificador(identificador: string): PrPersonaAlineable {
      let resultado: PrPersonaAlineable = null;

      if (this.lista.length > 0) {
        this.lista.forEach((valor: PrPersonaAlineable) => {
          if (valor.identificador == identificador) {
            resultado = valor;
          }
        });
      }

      return resultado;
    }

    /**
     * Devuelve el nombre completo del participante pasado como parámetro, en formato apellidos y nombre
     * @param participante Datos del participante
     */
    public ApellidosYNombrePorParticipante(participante: PrParticipacion): string {
      let resultado: string = "";

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrPersonaAlineable) => {
          if (valor.identificador.trim().toLowerCase() == participante.identificador.trim().toLowerCase()) {
            resultado = "<b>" + (valor.apellido1 != null ? valor.apellido1.trim() : "") + " " +
              (valor.apellido2 != null ? valor.apellido2.trim() : "") + "</b>, " +
              (valor.nombre != null ? valor.nombre.trim() : "") + " ";
          }
        });
      }

      return resultado;
    }

    /**
     * Devuelve el código del tipo de licencia, para el participante pasado como parámetro
     * @param participante Datos del participante
     */
    public CodigoTipoLicenciaPorParticipante(participante: PrParticipacion): string {
      let resultado: string = "";

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrPersonaAlineable) => {
          if (valor.identificador.trim().toLowerCase() == participante.identificador.trim().toLowerCase()) {
            resultado = valor.codigoTipoLicencia;
          }
        });
      }

      return resultado;
    }

    /**
     * Comprueba si la licencia cumple con las condiciones indicadas.
     * @param licencia Datos de la licencia
     * @param jugador Indica si debe ser jugador
     * @param entrenador Indica si debe ser entrenador
     * @param auxiliar Indica si debe ser auxiliar
     */
    private CumpleTipoAlineado(licencia: Online.PersonaAlineable, jugador: boolean, entrenador: boolean, auxiliar: boolean, otroAuxiliar: boolean) {
      let resultado: boolean = false;

      if (licencia != null) {
        if (jugador && !licencia.esEntrenador && !licencia.esAuxiliar) {
          resultado = true;
        }
        if (entrenador && (licencia.esEntrenador || licencia.tipoLicencia.toUpperCase().indexOf("ENTRENADOR") >= 0)) {
          resultado = true;
        }
        if ((auxiliar || otroAuxiliar) && (licencia.esAuxiliar || licencia.tipoLicencia.toUpperCase().indexOf("DELEGADO") >= 0)) {
          resultado = true;
        }
      }

      return resultado;
    }

    /**
     * Elimina de esta lista (y del servidor) la persona alineada pasada como parámetro
     * @param licencia Datos de la persona alineable a eliminar
     */
    public EliminarAlineado(licencia: Online.PersonaAlineable): void {
      if (this.lista && this.lista.length > 0) {
        this.lista.forEach((valor: PrPersonaAlineable, i: number) => {
          if (valor.identificador.trim().toUpperCase() == licencia.identificador.trim().toUpperCase()) {
            valor.Eliminar(this.designacion.idDesignacion)
              .then((resultado: boolean) => {
                this.lista.splice(i, 1);
              });
          }
        });
      }
    }

    /**
     * Devuelve el nombre completo del participante pasado como parámetro
     * @param participante Datos del participante
     */
    public NombreCompletoPorParticipante(participante: PrParticipacion): string {
      let resultado: string = "";

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrPersonaAlineable) => {
          if (valor.identificador.trim().toLowerCase() == participante.identificador.trim().toLowerCase()) {
            resultado = (valor.nombre != null ? valor.nombre.trim() : "") + " " +
              (valor.apellido1 != null ? valor.apellido1.trim() : "") + " " +
              (valor.apellido2 != null ? valor.apellido2.trim() : "");
          }
        });
      }

      return resultado;
    }

    /**
     * Obtiene la lista de las licencias que son alineables en el equipo actual. La lista se almacenará en la propiedad "lista" de la instancia
     * @param jugador Indica si se quiere obtener las licencias de tipo jugador
     * @param entrenador Indica si se quiere obtener las licencias de tipo entrenador
     * @param auxiliar Indica si se quiere obtener las licencias de tipo auxiliar
     * @param otroAuxiliar Indica que se quiere obtener las licencias de tipo otro auxiliar.
     */
    public ObtenerAlineables(jugador: boolean, entrenador: boolean, auxiliar: boolean, otroAuxiliar: boolean = false): Promise<boolean> {
      this.lista = [];
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.alineablesPorEquipo(this.designacion.urlApi, this.idEquipo, this.designacion.idDesignacion, this.designacion.fecha)
              .then((resultado: Array<Online.IPersonaAlineable>) => {
                // Creación del array con todas las personas alineables
                resultado.forEach((valor: Online.PersonaAlineable) => {
                  if (this.CumpleTipoAlineado(valor, jugador, entrenador, auxiliar, otroAuxiliar)) {
                    this.lista.push(Object.assign(new PrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes), valor));
                  }
                });

                if (this.lista != null && this.lista.length > 0) {
                  this.lista = this.OrdenarPorNombres(this.lista);
                }

                return Promise.resolve(true);
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener las personas alineables."));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.PersonasAlineables_PorDesignacionYEquipo(this.designacion.idDesignacion, this.idEquipo)
              .then((resultado: pouchdb2.PersonasAlineablesDB[]) => {
                // Creación del array con todas las designaciones
                resultado.forEach((valor: pouchdb2.PersonasAlineablesDB) => {
                  if (this.CumpleTipoAlineado(valor, jugador, entrenador, auxiliar, otroAuxiliar)) {
                    this.lista.push(<PrPersonaAlineable>valor);
                  }
                });

                if (this.lista != null && this.lista.length > 0) {
                  this.lista = this.OrdenarPorNombres(this.lista);
                }

                return Promise.resolve(true);
              })
              .catch(error => Promise.reject("No se han podido recuperar las personas alineables desde de la BD local."));
          }
        })
        .catch(error => Promise.reject("ERROR al obtener las personas alineables por equipo y fecha: " + error));
    }

    /**
     * Ordena la lista de personas alineables por sus apellidos y nombres
     * @param licencias Lista de personas alineables
     */
    public OrdenarPorNombres(licencias: Array<PrPersonaAlineable>): Array<PrPersonaAlineable> {
      licencias.sort((a: PrPersonaAlineable, b: PrPersonaAlineable) => {
        if (a.identificador == b.identificador) {
          return 0;
        }
        else if (a.apellido1.toUpperCase().trim() > b.apellido1.toUpperCase().trim() ||
          (a.apellido1.toUpperCase().trim() == b.apellido1.toUpperCase().trim() && a.apellido2.toUpperCase().trim() > b.apellido2.toUpperCase().trim()) ||
          (a.apellido1.toUpperCase().trim() == b.apellido1.toUpperCase().trim() && a.apellido2.toUpperCase().trim() == b.apellido2.toUpperCase().trim() && a.nombre.toUpperCase().trim() > b.nombre.toUpperCase().trim())) {
          return 1;
        }
        else {
          return -1;
        }
      });
      return licencias;
    }
  }

  // #endregion

  // #region Participantes
  export class PrParticipacion extends pouchdb2.ActasParticipacionDB implements iProxy {
    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      nombreTabla: string = "",
      _idRegistro: number = 0
    ) {
      super(nombreTabla, _idRegistro);
    }

    // #region Métodos principales

    public Eliminar(): Promise<boolean> {
      let datos: PrParticipacion = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            return this.CFutbolActas.eliminarParticipante(datos)
              .then((resultado: boolean) => {
                if (resultado) {
                  return Promise.resolve(resultado);
                }
                else {
                  return Promise.reject("No se han podido guardar los otros datos del acta en el servidor.");
                }
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            return Promise.resolve(true);
          }
        })
        .catch(error => Promise.reject("ERROR al guardar la participación de una persona: " + error));
    }

    public Guardar(): Promise<PrParticipacion> {
      // NOTA. Es necesario que se realice la conversión con "Object.assign", para que la llamada "post" funcione. Si se envía directamente "this", como tiene elementos que son servicios, no se envían los datos.

      let datos: PrParticipacion = Object.assign({}, this);
      datos.CFutbolActas = null;
      datos.DBService2 = null;
      datos.Persistentes = null;

      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            return this.CFutbolActas.guardarParticipante(datos)
              .then((resultado: Online.IActa_Participacion) => {
                if (resultado != null && resultado.idRegistro > 0) {
                  this.idRegistro = resultado.idRegistro;
                  return Promise.resolve(this);
                }
                else {
                  return Promise.reject("No se han podido guardar los otros datos del acta en el servidor.");
                }
              })
              .catch(error => Promise.reject("El servidor ha devuelto el error " + error));
          }
          else {
            return this.DBService2.Actas_Participacion_Guardar(datos)
              .then((resultado: pouchdb2.ActasParticipacionDB) => {
                if (resultado != null) {
                  this.idRegistro = resultado.idRegistro;
                  return Promise.resolve(this);
                }
                else {
                  return Promise.reject("No se han podido guardar los otros datos del acta en la BD Local.");
                }
              })
              .catch(error => Promise.reject("El guardado en la BD Local ha devuelto el error " + error));
          }
        })
        .catch(error => Promise.reject("ERROR al guardar la participación de una persona: " + error));
    }

    // #endregion
  }

  export class ListaPrParticipacion extends ConMensajes {
    public lista: Array<PrParticipacion>;

    constructor(
      public CFutbolActas: APIOnLine.CFutbolActas,
      public DBService2: pouchdb2.DBService2,
      public Persistentes: APIOnLine.Persistentes,
      public toastCtrl: ToastController,
      public designacion: PrDesignaciones,
      public idEquipo: number
    ) {
      super(toastCtrl);
      this.lista = [];
    }

    public CargarListaParticipacion(): Promise<boolean> {
      this.lista = [];
      return this.Persistentes.GetConfiguracion()
        .then((resultado: iConfiguracion) => {
          if (resultado.online) {
            // Versión ONLINE
            return this.CFutbolActas.participantes(this.designacion.urlApi, this.designacion.idDesignacion, this.idEquipo)
              .then((resultado: Array<Online.IActa_Participacion>) => {
                let aux: Array<PrParticipacion> = [];

                // Creación del array con todas las personas alineables
                resultado.forEach((valor: Online.IActa_Participacion) => {
                  let participa: PrParticipacion = new PrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes);
                  participa.urlApi = this.designacion.urlApi;
                  participa.urlNombre = this.designacion.urlNombre;
                  aux.push(Object.assign(participa, valor));
                });

                this.lista = aux;
                return Promise.resolve(true);
              })
              .catch(error => Promise.reject("El servidor ha devuelto un error al obtener las personas participantes (Actas_Participacion)."));
          }
          else {
            // Versión DESCONECTADA
            return this.DBService2.Actas_Participacion_PorDesignacionYEquipo(this.designacion.idDesignacion, this.idEquipo)
              .then((resultado: Array<pouchdb2.ActasParticipacionDB>) => {
                let aux: Array<PrParticipacion> = [];

                // Creación del array con todas las designaciones
                resultado.forEach((valor: pouchdb2.ActasParticipacionDB) => {
                  aux.push(<PrParticipacion>valor);
                });

                this.lista = aux;
                return Promise.resolve(true);
              })
              .catch(error => Promise.reject("No se han podido recuperar las personas alineables desde de la BD local."));
          }
        })
        .catch(error => Promise.reject("ERROR al obtener las personas alineables por equipo y fecha: " + error));
    }

    /**
     * Comprueba si se dan las condiciones para cumplir con los requisitos de alineación. Si se devuelve una cadena vacía, indica que se cumplen las condiciones. Si no, se especifican las condiciones que no se cumplen.
     */
    public CumpleCondicionesAlineacion(): string {
      let cumpleTitulares: boolean = true,
        cumpleEntrenador: boolean = false,
        cumpleDelegado: boolean = false,
        cumpleDelegadoCampo: boolean = false,
        cumpleCapitan: boolean = false;
      let plantilla: string = "En el equipo actual, NO HA COMPLETADO toda la información necesaria";

      // Titulares
      if (this.designacion.Configuracion.nTitulares != this.NumeroTitulares()) {
        cumpleTitulares = false;
        plantilla += ": Tiene menos titulares de los necesarios";
      }

      // Entrenador
      if (this.TieneEntrenador()) {
        cumpleEntrenador = true;
      }
      else {
        // Se comprueba si se ha indicado que no presenta entrenador
        if ((this.designacion.OtrosDatos.presentaEntrenadorLocal == false && this.designacion.EquipoLocal(this.idEquipo))
          || (this.designacion.OtrosDatos.presentaEntrenadorVisitante == false && !this.designacion.EquipoLocal(this.idEquipo))) {
          cumpleEntrenador = true;
        }
        else {
          plantilla += ": No se ha establecido el ENTRENADOR";
        }
      }
      // Capitan
      if (this.TieneCapitan()) {
        cumpleCapitan = true;
      }
      else {
        plantilla += ": No se ha establecido el CAPITÁN";
      }
      // Delegado
      if (this.TieneDelegado(false)
        || (this.designacion.EquipoLocal(this.idEquipo) && this.designacion.OtrosDatos.noExisteDelegadoEquipoLocal)
        || (!this.designacion.EquipoLocal(this.idEquipo) && this.designacion.OtrosDatos.noExisteDelegadoEquipoVisitante)) {
        cumpleDelegado = true;
      }
      else {
        plantilla += ": No se ha establecido el DELEGADO";
      }
      // Delegado de campo
      if ((this.designacion.EquipoLocal(this.idEquipo) && this.TieneDelegado(true))
        || !this.designacion.EquipoLocal(this.idEquipo)
        || (this.designacion.EquipoLocal(this.idEquipo) && this.designacion.OtrosDatos.noExisteDelegadoCampo)) {
        cumpleDelegadoCampo = true;
      }
      else {
        plantilla += ": No se ha establecido el DELEGADO DE CAMPO";
      }

      if (this.lista == undefined || this.lista.length == 0 || this.lista.filter(m => m.esTitular || m.esSuplente).length == 0 || (cumpleCapitan && cumpleDelegado && cumpleDelegadoCampo && cumpleEntrenador && cumpleTitulares)) {
        return "";
      }
      else {
        return plantilla;
      }
    }

    /**
     * Devuelve los datos de la persona que está marcada como delegado de equipo
     * @param licencias Lista de licencias
     */
    public DatosDelegado(licencias: Array<PrPersonaAlineable>): PrPersonaAlineable | null {
      let licencia: PrPersonaAlineable = null;

      if (licencias && licencias.length > 0 && this.lista && this.lista.length > 0) {
        this.lista.forEach((participa: PrParticipacion) => {
          licencias.forEach((datos: PrPersonaAlineable) => {
            if (participa.esDelegado && participa.identificador == datos.identificador) {
              licencia = datos;
            }
          })
        });
      }

      return licencia;
    }

    /**
     * Devuelve los datos de la persona que está marcada como delegado de campo
     * @param licencias Lista de licencias
     */
    public DatosDelegadoCampo(licencias: Array<PrPersonaAlineable>): PrPersonaAlineable | null {
      let licencia: PrPersonaAlineable = null;

      if (licencias && licencias.length > 0 && this.lista && this.lista.length > 0) {
        this.lista.forEach((participa: PrParticipacion) => {
          licencias.forEach((datos: PrPersonaAlineable) => {
            if (participa.esDelegadoCampo && participa.identificador == datos.identificador) {
              licencia = datos;
            }
          })
        });
      }

      return licencia;
    }

    /**
     * Devuelve los datos de la persona que está marcada como entrenador
     * @param licencias Lista de personas del equipo
     */
    public DatosEntrenador(licencias: Array<PrPersonaAlineable>): PrPersonaAlineable | null {
      let licencia: PrPersonaAlineable = null;

      if (licencias && licencias.length > 0 && this.lista && this.lista.length > 0) {
        this.lista.forEach((participa: PrParticipacion) => {
          licencias.forEach((datos: PrPersonaAlineable) => {
            if (participa.esEntrenador && participa.identificador == datos.identificador) {
              licencia = datos;
            }
          })
        });
      }

      return licencia;
    }

    /**
     * Devuelve los datos de participación del delegado de equipo o delegado de campo, en la lista de participación actual.
     * @param campo Indica si se pregunta por el delegado de campo o el delegado de equipo
     */
    public Delegado(campo: boolean): PrParticipacion {
      let resultado: PrParticipacion = null;

      if (this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if ((campo && valor.esDelegadoCampo) || (!campo && valor.esDelegado)) {
            resultado = valor;
          }
        })
      }

      return resultado;
    }

    /**
     * Número de dorsal que lleva la persona. 0 si no se ha establecido un dorsal
     * @param licencia Datos de la persona alineable
     */
    public Dorsal(licencia: PrPersonaAlineable): number {
      let resultado: number = 0;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador && valor.dorsal > 0) {
            resultado = valor.dorsal;
          }
        });
      }

      return resultado;
    }

    /**
     * Indica si el número de dorsal ya está siendo utilizado
     * @param dorsal Dorsal a comprobar
     */
    public DorsalUsado(dorsal: number): boolean {
      let resultado: boolean = false;

      this.lista.forEach((valor: PrParticipacion) => {
        if (valor.dorsal == dorsal) {
          resultado = true;
        }
      });
      return resultado;
    }

    public EsCapitan(licencia: PrPersonaAlineable): boolean {
      let resultado: boolean = false;

      if (this.lista != null && this.lista.length > 0 && licencia != null) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (licencia.identificador == valor.identificador && valor.esCapitan) {
            resultado = true;
          }
        });
      }
      return resultado;
    }

    /**
     * Indica si la licencia pasada como parámetro es delegado o delegado de campo
     * @param licencia Datos de la persona alineable
     * @param campo Indica si hay que comprobar que es delegado de campo o delegado de equipo
     */
    public EsDelegado(licencia: PrPersonaAlineable, campo: boolean): boolean {
      let resultado: boolean = false;

      if (this.lista != null && this.lista.length > 0 && licencia != null) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (licencia.identificador == valor.identificador && ((valor.esDelegado && !campo) || (valor.esDelegadoCampo && campo))) {
            resultado = true;
          }
        });
      }
      return resultado;
    }

    /**
     * Indica si la persona no es del equipo actual no es una persona introducida desde la APP
     * @param licencia Datos de la persona alineable
     * @param idEquipo Identificador del equipo actual
     */
    public EsDeOtroEquipo(licencia: PrPersonaAlineable, idEquipo: number): boolean {
      if (licencia && (licencia.idEquipo != idEquipo) || (licencia.sinLicencia)) {
        return true;
      }
      else {
        return false;
      }
    }

    /**
     * Indica si la licencia pasada como parámetro está marcada como entrenador
     * @param licencia  Datos de la persona alineable
     */
    public EsEntrenador(licencia: PrPersonaAlineable): boolean {
      let resultado: boolean = false;

      if (this.lista != null && this.lista.length > 0 && licencia != null) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (licencia.identificador == valor.identificador && valor.esEntrenador) {
            resultado = true;
          }
        });
      }
      return resultado;
    }

    public EsSuplente(licencia: PrPersonaAlineable): boolean {
      let resultado: boolean = false;

      if (this.lista != null && this.lista.length > 0 && licencia != null) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (licencia.identificador == valor.identificador && valor.esSuplente) {
            resultado = true;
          }
        });
      }
      return resultado;
    }

    /**
     * Indica si la licencia esta alineada
     */
    public EstaAlineado(licencia: PrPersonaAlineable): boolean {
      let resultado: boolean = false;

      this.lista.forEach((valor: PrParticipacion) => {
        if (valor.identificador == licencia.identificador) {
          resultado = true;
        }
      });

      return resultado;
    }

    /**
     * Cambia el dorsal de la persona alineable
     * @param licencia Datos de la persona alineable
     * @param dorsal Dorsal a establecer
     */
    public EstablecerDorsal(licencia: PrPersonaAlineable, dorsal: number): void {
      // Se comprueba si el dorsal ya está utilizado, para quitarlo
      this.lista.forEach((valor: PrParticipacion) => {
        if (valor.dorsal == dorsal && (licencia.dorsal == null || licencia.dorsal == 0)) {
          valor.dorsal = 0;
          valor.Guardar()
            .then((resultado: PrParticipacion) => {
              valor = resultado;
            });
        }
      });

      // Establece el dorsal a la licencia
      this.lista.forEach((valor: PrParticipacion) => {
        if (valor.identificador == licencia.identificador) {
          if (licencia.dorsal == null || licencia.dorsal == 0) {
            valor.dorsal = dorsal;
          }
          else {
            valor.dorsal = licencia.dorsal;
          }
          valor.Guardar()
            .then((resultado: PrParticipacion) => {
              valor = resultado;
            });
        }
      });
    }

    /**
     * Comprueba si hay que establecer los dorsales para los participantes
     * @param licencias Lista de licencias actuales (personas alineables)
     */
    public EstablecerDorsalesFijos(licencias: Proxy.ListaPrPersonaAlineable): Promise<boolean> {
      let promesas: Promise<PrParticipacion>[] = [];

      licencias.lista.forEach((licencia: PrPersonaAlineable) => {
        if (licencia.dorsal != null && licencia.dorsal > 0) {
          let encontrado: boolean = false;

          this.lista.forEach((participante: PrParticipacion) => {
            if (participante.identificador == licencia.identificador) {
              encontrado = true;
            }
          });

          if (!encontrado) {
            // Incluir nuevo registro de participación
            let participa: PrParticipacion = new PrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes);
            participa.idDesignacion = this.designacion.idDesignacion;
            participa.idEquipo = this.idEquipo;
            participa.identificador = licencia.identificador;
            participa.urlApi = this.designacion.urlApi;
            participa.urlNombre = this.designacion.urlNombre;
            participa.dorsal = licencia.dorsal;

            promesas.push(participa.Guardar());
          }
        }
      });

      if (promesas.length > 0) {
        return Promise.all(promesas)
          .then((resultado: PrParticipacion[]) => {
            this.lista = resultado;

            return Promise.resolve(true);
          });
      }
      else {
        return Promise.resolve(true);
      }
    }

    public EsTitular(licencia: PrPersonaAlineable): boolean {
      let resultado: boolean = false;

      if (this.lista != null && this.lista.length > 0 && licencia != null) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (licencia.identificador == valor.identificador && valor.esTitular) {
            resultado = true;
          }
        });
      }
      return resultado;
    }

    /**
     * Elimina completamente la información introducida de los jugadores de la alineación
     */
    public EliminarAlineados(licencias: Proxy.ListaPrPersonaAlineable = null): void {
      this.lista.forEach((valor: PrParticipacion) => {
        if (valor.esTitular || valor.esSuplente || valor.esCapitan) {
          valor.esTitular = false;
          valor.esSuplente = false;
          valor.esCapitan = false;
          if (licencias != null && licencias.lista.filter(m => m.identificador == valor.identificador && m.dorsal != null && m.dorsal > 0).length > 0) {
            valor.dorsal = licencias.lista.filter(m => m.identificador == valor.identificador)[0].dorsal;
          }
          else {
            valor.dorsal = 0;
          }
          valor.Guardar()
            .then((resultado: PrParticipacion) => {
              valor = resultado;
            });
        }
      });
    }

    /**
     * Elimina el entrenador de la lista de participantes
     * @returns Booleano que indica si se ha realizado correctamente la operación de eliminación
     */
    public EliminarEntrenador(): Promise<boolean> {
      let aux: Array<Promise<PrParticipacion>> = [];
      this.lista.forEach((valor: PrParticipacion) => {
        if (valor.esEntrenador) {
          valor.esEntrenador = false;
          aux.push(valor.Guardar());
        }
      });

      if (aux.length > 0) {
        Promise.all(aux)
          .then((resultado: Array<PrParticipacion>) => {
            if (resultado != null && resultado.length > 0) {
              // Actualización de los valores en la lista de licencias
              resultado.forEach((valorA: PrParticipacion) => {
                this.lista.forEach((valorB: PrParticipacion) => {
                  if (valorA.identificador == valorB.identificador) {
                    valorB = valorA;
                  }
                });
              });
            }
            return Promise.resolve(true);
          })
          .catch(error => Promise.reject(error));
      }
      else {
        return Promise.resolve(true);
      }
    }

    /**
     * Elimina completamente la información introducida de los delegados
     */
    public EliminarDelegados(): Promise<boolean> {
      let aux: Array<Promise<PrParticipacion>> = [];
      this.lista.forEach((valor: PrParticipacion) => {
        if (valor.esDelegado || valor.esDelegadoCampo) {
          valor.esDelegadoCampo = false;
          valor.esDelegado = false;
          aux.push(valor.Guardar());
        }
      });

      if (aux != null && aux.length > 0) {
        Promise.all(aux)
          .then((resultado: Array<PrParticipacion>) => {
            if (resultado != null && resultado.length > 0) {
              // Actualización de los valores en la lista de licencias
              resultado.forEach((valorA: PrParticipacion) => {
                this.lista.forEach((valorB: PrParticipacion) => {
                  if (valorA.identificador == valorB.identificador) {
                    valorB = valorA;
                  }
                });
              });
            }
            return Promise.resolve(true);
          })
          .catch(error => Promise.reject(error));
      }
      else {
        return Promise.resolve(true);
      }
    }

    /**
     * Elimina el participante de la lista de participación
     * @param licencia Licencia del participante
     */
    public EliminarParticipante(licencia: PrPersonaAlineable): Promise<boolean> {
      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion, i: number) => {
          if (licencia.identificador == valor.identificador) {
            return valor.Eliminar()
              .then((resultado: boolean) => {
                this.lista.splice(i, 1);
                return Promise.resolve(true);
              });
          }
          else {
            return Promise.resolve(false);
          }
        });
      }
      else {
        return Promise.resolve(false);
      }
    }

    /**
     * Devuelve la lista de participantes (titulares o que han entrado en el campo desde el banquillo) de la lista completa de alineados
     */
    public HanParticipado(cambios: ListaPrCambios): Array<PrParticipacion> {
      let resultado: Array<PrParticipacion> = [];

      if (this.lista != null && this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.esTitular || valor.participa) {
            resultado.push(valor);
          }
          else if (cambios != null) {
            cambios.lista.forEach((cambio: PrCambios) => {
              if (cambio.entra == valor.dorsal) {
                resultado.push(valor);
              }
            });
          }
        });
      }

      return resultado;
    }

    /**
     * Incluye la licencia pasada como parámetro, en la lista de participantes
     * @param licencia   Datos de la persona alineada
     */
    public MarcarComoAlineado(licencia: PrPersonaAlineable): void {
      let encontrado: boolean = false;
      // Comprueba que no esté ya alineado, para no meterlo dos veces
      this.lista.forEach((valor: PrParticipacion) => {
        if (licencia.identificador == valor.identificador) {
          encontrado = true;
        }
      });

      if (!encontrado) {
        // Incluir nuevo registro de participación
        let participa: PrParticipacion = new PrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes);
        participa.idDesignacion = this.designacion.idDesignacion;
        participa.idEquipo = this.idEquipo;
        participa.identificador = licencia.identificador;
        participa.urlApi = this.designacion.urlApi;
        participa.urlNombre = this.designacion.urlNombre;
        participa.Guardar()
          .then((resultado: PrParticipacion) => {
            this.lista.push(resultado);
          });
      }
    }

    /**
     * Marca o desmarca la licencia como capitán
     * @param licencia Datos de la persona alineable
     */
    public MarcarComoCapitan(licencia: PrPersonaAlineable): void {
      // Comprueba si es para desmarcar
      if (this.EsCapitan(licencia)) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            valor.esCapitan = false;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });
      }
      else {
        // Búsqueda de la licencia actual como capitán, para quitarle la marca
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.esCapitan && valor.identificador != licencia.identificador) {
            valor.esCapitan = false;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });

        // Marcar la licencia pasada como capitán
        let encontrado: boolean = false;
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            valor.esCapitan = true;
            encontrado = true;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });

        if (!encontrado) {
          // Incluir nuevo registro de participación
          let participa: PrParticipacion = new PrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes);
          participa.idDesignacion = this.designacion.idDesignacion;
          participa.idEquipo = this.idEquipo;
          participa.identificador = licencia.identificador;
          participa.esCapitan = true;
          participa.urlApi = this.designacion.urlApi;
          participa.urlNombre = this.designacion.urlNombre;
          participa.Guardar()
            .then((resultado: PrParticipacion) => {
              this.lista.push(resultado);
            });
        }
      }
    }

    /**
     * Marca a la persona como delegado de equipo y delegado de campo
     * @param licencia Datos de la persona alineable
     */
    public MarcarDobleFuncion(licencia: PrPersonaAlineable): void {
      console.log("Llego al marcado de la doble función");
      // Comprueba si es para desmarcar
      if (this.EsDelegado(licencia, false)) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador && valor.esDelegado) {
            valor.esDelegadoCampo = false;
            valor.esDelegado = false;
          }
          valor.Guardar()
            .then((resultado: PrParticipacion) => {
              valor = resultado;
            });
        });
      }
      else {
        // Búsqueda de la licencia actual que sea delegado y delegado de campo, para quitar esas marcas
        if (this.lista != null && this.lista.length > 0) {
          this.lista.forEach((valor: PrParticipacion) => {
            let modificado: boolean = false;

            if (valor.esDelegadoCampo) {
              valor.esDelegadoCampo = false;
              modificado = true;
            }
            if (valor.esDelegado) {
              valor.esDelegado = false;
              modificado = true;
            }

            if (modificado) {
              valor.Guardar()
                .then((resultado: PrParticipacion) => {
                  valor = resultado;;
                });
            }
          });
        }

        // Marcar la licencia pasada como delegado y delegado de campo
        let encontrado: boolean = false;
        if (this.lista != null && this.lista.length > 0) {
          this.lista.forEach((valor: PrParticipacion) => {
            if (valor.identificador.toUpperCase().trim() == licencia.identificador.toUpperCase().trim()) {
              encontrado = true;
              valor.esDelegado = true;
              valor.esDelegadoCampo = true;
              valor.Guardar()
                .then((resultado: PrParticipacion) => {
                  valor = resultado;
                });
            }
          });
        }

        // En el caso de que no se haya encontrado, hay que guardar el nuevo registro
        if (!encontrado) {
          let participa: PrParticipacion = new PrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes);
          participa.idDesignacion = this.designacion.idDesignacion;
          participa.idEquipo = this.idEquipo;
          participa.identificador = licencia.identificador;
          participa.esDelegadoCampo = true;
          participa.esDelegado = true;
          participa.urlApi = this.designacion.urlApi;
          participa.urlNombre = this.designacion.urlNombre;
          participa.Guardar()
            .then((resultado: PrParticipacion) => {
              this.lista.push(resultado);
            });
        }
      }
    }

    /**
     * Marca o desmarca la licencia como delegado o delegado de campo
     * @param licencia Datos de la persona alineable
     * @param campo Indica si es para marcar el delegado de campo o de equipo
     */
    public MarcarComoDelegado(licencia: PrPersonaAlineable, campo: boolean): void {
      // Comprueba si es para desmarcar
      if (this.EsDelegado(licencia, campo)) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador && campo && valor.esDelegadoCampo) {
            valor.esDelegadoCampo = false;
          }
          else if (valor.identificador == licencia.identificador && !campo && valor.esDelegado) {
            valor.esDelegado = false;
          }
          valor.Guardar()
            .then((resultado: PrParticipacion) => {
              valor = resultado;
            });
        });
      }
      else {
        // Búsqueda de la licencia actual que sea delegado, para quitar esa marca
        if (this.lista != null && this.lista.length > 0) {
          this.lista.forEach((valor: PrParticipacion) => {
            if (campo && valor.esDelegadoCampo) {
              valor.esDelegadoCampo = false;
            }
            if (!campo && valor.esDelegado) {
              valor.esDelegado = false;
            }
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          });
        }

        // Marcar la licencia pasada como delegado
        let encontrado: boolean = false;
        if (this.lista != null && this.lista.length > 0) {
          this.lista.forEach((valor: PrParticipacion) => {
            if (valor.identificador.toUpperCase().trim() == licencia.identificador.toUpperCase().trim()) {
              encontrado = true;
              if (campo) {
                valor.esDelegadoCampo = true;
              }
              else {
                valor.esDelegado = true;
              }
              valor.Guardar()
                .then((resultado: PrParticipacion) => {
                  valor = resultado;
                });
            }
          });
        }

        if (!encontrado) {
          // Incluir nuevo registro de participación
          let participa: PrParticipacion = new PrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes);
          participa.idDesignacion = this.designacion.idDesignacion;
          participa.idEquipo = this.idEquipo;
          participa.identificador = licencia.identificador;
          participa.urlApi = this.designacion.urlApi;
          participa.urlNombre = this.designacion.urlNombre;
          if (campo) {
            participa.esDelegadoCampo = true;
          }
          else {
            participa.esDelegado = true;
          }
          participa.Guardar()
            .then((resultado: PrParticipacion) => {
              this.lista.push(resultado);
            });
        }
      }
    }

    /**
     * Marca o desmarca la licencia como entrenador
     * @param licencia    Datos de la persona alineable
     */
    public MarcarComoEntrenador(licencia: PrPersonaAlineable): void {
      // Comprueba si es para descarmar al entranador
      if (this.EsEntrenador(licencia)) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            valor.esEntrenador = false;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });
      }
      else {
        // Desmarcado del entrenador anterior si lo hubiere
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador != licencia.identificador && valor.esEntrenador) {
            valor.esEntrenador = false;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });

        // Marcar la licencia pasada como parámetro
        let encontrado: boolean = false;
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            encontrado = true;
            valor.esEntrenador = true;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });

        if (!encontrado) {
          // Incluir nuevo registro de participación
          let participa: PrParticipacion = new PrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes);
          participa.idDesignacion = this.designacion.idDesignacion;
          participa.idEquipo = this.idEquipo;
          participa.identificador = licencia.identificador;
          participa.esEntrenador = true;
          participa.urlApi = this.designacion.urlApi;
          participa.urlNombre = this.designacion.urlNombre;
          participa.Guardar()
            .then((resultado: PrParticipacion) => {
              this.lista.push(resultado);
            });
        }
      }
    }

    /**
     * Marca como suplente a la persona pasada como parámetro. Si es titular, lo desmarca
     * @param licencia Datos de la persona alineable
     */
    public MarcarComoSuplente(licencia: PrPersonaAlineable): void {
      if (this.EsSuplente(licencia)) {
        // Desmarcar como suplente
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            valor.esSuplente = false;
            if (licencia.dorsal == null || licencia.dorsal == 0) {
              valor.dorsal = 0;
            }
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });
      }
      else if (this.EsTitular(licencia)) {
        // Desmarcado como titular
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            valor.esTitular = false;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
                this.MarcarComoSuplente_segundaParte(licencia);
              });
          }
        });
      }
      else {
        this.MarcarComoSuplente_segundaParte(licencia);
      }
    }

    private MarcarComoSuplente_segundaParte(licencia: PrPersonaAlineable): void {
      let dorsal: number = this.UltimoDorsal();

      if (licencia.dorsal == null || licencia.dorsal == 0) {
        if (typeof dorsal == "string") {
          dorsal = parseInt(dorsal);
        }
        dorsal += 1;
      }
      else {
        dorsal = licencia.dorsal;
      }

      // Comprueba si ya se han marcado todos los suplentes
      if ((this.designacion.Configuracion.nJugadoresEnActa - this.designacion.Configuracion.nTitulares) > this.NumeroSuplentes()) {
        let encontrado: boolean = false;
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            encontrado = true;
            valor.esSuplente = true;
            valor.dorsal = dorsal;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });

        if (!encontrado) {
          // Incluir nuevo registro de participación
          let participa: PrParticipacion = new PrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes);
          participa.idDesignacion = this.designacion.idDesignacion;
          participa.idEquipo = this.idEquipo;
          participa.identificador = licencia.identificador;
          participa.esSuplente = true;
          participa.dorsal = dorsal;
          participa.urlApi = this.designacion.urlApi;
          participa.urlNombre = this.designacion.urlNombre;
          participa.Guardar()
            .then((resultado: PrParticipacion) => {
              this.lista.push(resultado);
            });
        }
      }
      else {
        let texto: string = (this.designacion.Configuracion.nJugadoresEnActa - this.designacion.Configuracion.nTitulares).toString();
        this.Mensaje("El número de suplentes no puede ser superior a " + texto, 4000);
      }
    }

    /**
     * Marca como titular a la persona pasada como parámetro. Si es suplente, la desmarca de suplente
     * @param licencia Datos de la persona alineable
     */
    public MarcarComoTitular(licencia: PrPersonaAlineable): void {
      if (this.EsTitular(licencia)) {
        // Desmarcado de titular
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            valor.esTitular = false;
            if (licencia.dorsal == null || licencia.dorsal == 0) {
              valor.dorsal = 0;
            }
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });
      }
      else if (this.EsSuplente(licencia)) {
        // Desmarcado como suplente
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            valor.esSuplente = false;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
                this.MarcarComoTitular_segundaParte(licencia);
              });
          }
        });
      }
      else {
        this.MarcarComoTitular_segundaParte(licencia);
      }
    }

    private MarcarComoTitular_segundaParte(licencia: PrPersonaAlineable): void {
      let dorsal: any = this.UltimoDorsal();

      if (licencia.dorsal == null || licencia.dorsal == 0) {
        if (typeof dorsal == "string") {
          dorsal = parseInt(dorsal);
        }
        dorsal += 1;
      }
      else {
        dorsal = licencia.dorsal;
      }

      // Comprueba si ya se han marcado todos los titulares.
      if (this.designacion.Configuracion.nTitulares > this.NumeroTitulares()) {
        let encontrado: boolean = false;
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            encontrado = true;
            valor.esTitular = true;
            valor.dorsal = dorsal;
            valor.Guardar()
              .then((resultado: PrParticipacion) => {
                valor = resultado;
              });
          }
        });

        if (!encontrado) {
          // Incluir nuevo registro de participación
          let participa: PrParticipacion = new PrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes);
          participa.idDesignacion = this.designacion.idDesignacion;
          participa.idEquipo = this.idEquipo;
          participa.identificador = licencia.identificador;
          participa.esTitular = true;
          participa.dorsal = dorsal;
          participa.urlApi = this.designacion.urlApi;
          participa.urlNombre = this.designacion.urlNombre;
          participa.Guardar()
            .then((resultado: PrParticipacion) => {
              this.lista.push(resultado);
            });
        }
      }
      else {
        this.Mensaje("El número de titulares no puede ser superior a " + this.designacion.Configuracion.nTitulares, 4000);
      }
    }

    public NumeroDorsales(): number {
      let resultado: number = 0;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.dorsal > 0) {
            resultado += 1;
          }
        });
      }

      return resultado;
    }

    public NumeroSuplentes(): number {
      let resultado: number = 0;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.esSuplente) {
            resultado += 1;
          }
        });
      }

      return resultado;
    }

    public NumeroTitulares(): number {
      let resultado: number = 0;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.esTitular) {
            resultado += 1;
          }
        });
      }

      return resultado;
    }

    /**
     * Ordena la lista de personas alineadas por sus dorsales
     * @param licencias Lista de personas alineadas
     * @param conDorsal Indica si solamente se quieren devolver las licencias que tengan dorsal
     * @param soloParticipantes Indica si se quiere obtener solamente la lista de jugadores que hayan participado (que sea titular, que sea suplente o que haya participado)
     */
    public OrdenarPorDorsales(licencias: Array<PrPersonaAlineable>, conDorsal: boolean = false, soloParticipantes: boolean = false): Array<PrPersonaAlineable> {
      // Ordenación con el método sort de Javascript
      licencias.sort((a: PrPersonaAlineable, b: PrPersonaAlineable) => {
        if (a.identificador == b.identificador) {
          return 0;
        }
        else if (this.Dorsal(a) > 0 && this.Dorsal(b) > 0 && this.Dorsal(a) > this.Dorsal(b)) {
          return 1;
        }
        else if (this.Dorsal(a) == 0 && this.Dorsal(b) > 0) {
          // Los dorsales iguales a 0, se envían al final
          return 1;
        }
        else if (this.Dorsal(a) == 0 && this.Dorsal(b) == 0) {
          // Ordenación por apellidos
          if (a.apellido1.toUpperCase().trim() > b.apellido1.toUpperCase().trim() ||
            (a.apellido1.toUpperCase().trim() == b.apellido1.toUpperCase().trim() && a.apellido2.toUpperCase().trim() > b.apellido2.toUpperCase().trim()) ||
            (a.apellido1.toUpperCase().trim() == b.apellido1.toUpperCase().trim() && a.apellido2.toUpperCase().trim() == b.apellido2.toUpperCase().trim() && a.nombre.toUpperCase().trim() > b.nombre.toUpperCase().trim())) {
            return 1;
          }
          return -1;
        }
        else {
          return -1;
        }
      });

      // Comprobar si se desea obtener solamente las personas con dorsal
      if (conDorsal) {
        let aux: Array<PrPersonaAlineable> = [];

        licencias.forEach((valor: PrPersonaAlineable) => {
          if (this.Dorsal(valor) > 0) {
            aux.push(valor);
          }
        });

        licencias = aux;
      }

      // Comprueba que sean personas que hayan sido alineadas (participantes)
      if (soloParticipantes) {
        let aux: PrPersonaAlineable[] = [];

        licencias.forEach((valor: PrPersonaAlineable) => {
          if (this.EsTitular(valor) || this.EsSuplente(valor)) {
            aux.push(valor);
          }
          else {
            let participante: PrParticipacion = this.PorLicencia(valor);
            if (participante.participa) {
              aux.push(valor);
            }
          }
        });

        licencias = aux;
      }

      return licencias;
    }

    /**
     * Devuelve el registro de participación asociado con la licencia (persona) pasada como parámetro
     * @param licencia Datos de la licencia
     */
    public PorLicencia(licencia: PrPersonaAlineable): PrParticipacion {
      let resultado: PrParticipacion = null;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.identificador == licencia.identificador) {
            resultado = valor;
          }
        });
      }

      return resultado;
    }

    /**
     * Devuelve los datos del participante según su ID
     * @param idParticipante Identificador del participante (idRegistro)
     */
    public PorId(idParticipante: number): PrParticipacion {
      let resultado: PrParticipacion = null;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.idRegistro == idParticipante) {
            resultado = valor;
          }
        });
      }

      return resultado;
    }

    /**
     * Devuelve el participante cuyo dorsal es pasado como parámetro
     * @param _dorsal Dorsal a buscar
     */
    public PorDorsal(_dorsal: number): PrParticipacion {
      let resultado: PrParticipacion = null;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.dorsal == _dorsal) {
            resultado = valor;
          }
        });
      }

      return resultado;
    }

    public TieneCapitan(): boolean {
      let resultado: boolean = false;

      if (this.TieneParticipantes()) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.esCapitan) {
            resultado = true;
          }
        });
      }
      else {
        resultado = true;
      }

      return resultado;
    }

    /**
     * Indica si con los datos de los participantes, se tiene delegado
     * @param campo Indica si es el delegado de campo
     * @param comprobarTieneParticipantes Indica si se debe comprobar que haya participantes o no. Por defecto, se comprueba.
     *        Es necesario para que se pueda comprobar si se tiene delegado cuando no hay participantes.
     * @returns Booleano que indica si se ha establecido el delegado correspondiente
     */
    public TieneDelegado(campo: boolean, comprobarTieneParticipantes: boolean = true): boolean {
      if (!this.TieneParticipantes() && comprobarTieneParticipantes) {
        return true;
      } else {
        return this.TieneDelegadoMarcado(campo);
      }
    }

    public TieneDelegadoMarcado(campo: boolean): boolean {
      if (campo) {
        return this.lista.filter(m => m.esDelegadoCampo).length > 0;
      } else {
        return this.lista.filter(m => m.esDelegado).length > 0;
      }
    }

    /**
     * Indica si la licencia tiene dorsal
     * @param licencia Datos de la persona alineable
     */
    public TieneDorsal(licencia: PrPersonaAlineable): boolean {
      if (this.Dorsal(licencia) > 0) {
        return true;
      }
      else {
        return false;
      }
    }

    /**
     * Indica si tiene entrenador
     */
    public TieneEntrenador(): boolean {
      let resultado: boolean = false;

      if (this.TieneParticipantes()) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.esEntrenador) {
            resultado = true;
          }
        });
      }
      else {
        resultado = true;
      }

      return resultado;
    }

    /**
     * Indica si hay algún participante que no sea titular o que no esté marcado como participante (no participa)
     */
    public TodosParticipan(): boolean {
      let resultado: boolean = true;

      if (this.lista != null && this.lista.length > 0) {
        if (this.lista.filter(m => m.esSuplente && !m.participa).length > 0) {
          resultado = false;
        }
      }

      return resultado;
    }

    /**
     * Comprueba si se han establecido participantes
     * @returns Booleano con el resultado de la comprobación
     */
    public TieneParticipantes(): boolean {
      if (this.lista != undefined && this.lista.length > 0 && this.lista.filter(m => m.esTitular || m.esSuplente).length > 0) {
        return true;
      }
      else {
        return false;
      }
    }

    public UltimoDorsal(): number {
      let resultado: number = 0;

      if (this.lista != null && this.lista.length > 0) {
        this.lista.forEach((valor: PrParticipacion) => {
          if (valor.dorsal > resultado) {
            resultado = valor.dorsal;
          }
        });
      }

      return resultado;
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/services/proxy/proxy.service.ts